<template>
  <div>
    <gc-filter-split-view
      :showLeftContainer="showLeftContainer"
      :showRightContainer="showRightContainer"
      :rightContainerWidth="250"
    >
      <template #leftContent>
        <!-- {{ getGridHeight }} -->
        <!-- {{ gridColumns }} -->
        <!-- {{ gridLoadingCompleted }} -->

        <dx-data-grid
          :ref="gridRef"
          v-if="gridLoadingCompleted"
          :data-source="dataSourceConfigComputed"
          :columns="gridColumns"
          :height="getGridHeight - heightPadding"
          @toolbar-preparing="onToolbarPreparing($event)"
          @exporting="
            onGridToExcelExporting($event, exportFileName, gridColumns)
          "
          @option-changed="onOptionChanged"
          @content-ready="onContentReady"
          @cellPrepared="onCellPrepared($event, getSubTotals)"
          @cell-click="rowClick($event)"
          :remote-operations="setRemoteOperations"
          @row-removed="rowRemoved"
          :elementAttr="{ class: elementAttrClass }"
          :key-expr="
            keyExpr
              ? keyExpr
              : setKeyboardNavigation() != false
              ? setKeyboardNavigation().key
              : undefined
          "
          :on-focused-cell-changing="onFocusedCellChanging"
          :on-focused-cell-changed="onFocusedCellChanged"
          @editor-preparing="onEditorPreparing"
          @editor-prepared="onEditorPrepared"
          @selection-changed="onSelectionChanged"
          @key-down="onKeyDown"
          :onRowDblClick="onRowDblClick"
          :row-alternation-enabled="rowAlternationEnabled"
          @rowPrepared="onRowPrepared"
          :selectionFilter="getSelectionFilter"
        >
          <DxExport :enabled="true" :formats="['pdf', 'xlsx']" />
          <DxKeyboardNavigation
            :edit-on-key-press="true"
            :enter-key-action="'startEdit'"
            :enter-key-direction="'none'"
            :enabled="
              setKeyboardNavigation() != false
                ? setKeyboardNavigation().enabled
                : false
            "
          />
          <DxPaging
            :page-size="
              gridOptions && gridOptions.options && gridOptions.options.pageSize
                ? gridOptions.options.pageSize
                : 100
            "
            :enabled="
              gridOptions &&
              gridOptions.options &&
              gridOptions.options.dxPaging != undefined
                ? gridOptions.options.dxPaging
                : true
            "
          />

          <!-- <DxSearchPanel :visible="true" disabled /> -->
          <DxStateStoring
            :enabled="persistenceKey ? true : false"
            :storage-key="getPersistenceKey"
            type="custom"
            :custom-load="customLoadState"
            :custom-save="customSaveState"
            :savingTimeout="10"
          />

          <template #toolbar-pdf-preview>
            <gc-toolbar-print-preview
              :data="previewPdfs"
              :dataModel="dataModel"
              :showLoading="showLoading"
              v-if="
                gridToolbar.pdf == true &&
                gridToolbar.screenName &&
                previewPdfs.length > 0
              "
            />
          </template>

          <template #toolbar-multiple-pdf-preview>
            <gc-toolbar-print-preview
              :data="previewPdfs"
              :selectedRowData="selectedRowData"
              :dataModel="dataModel"
              :showLoading="showLoading"
              :gridColumns="gridColumns"
              v-if="previewPdfs.length > 0"
            />
          </template>

          <template #toolbar-email-preview>
            <gc-toolbar-email
              :data="emailRecords"
              :dataModel="dataModel"
              :showLoading="showLoading"
              :menuItems="gridToolbar.emailMenuItems"
              :baseView="baseView"
            />
          </template>

          <template #status-chip>
            <gc-status-chip
              :status="dataModel.Status ? dataModel.Status : ''"
            />
          </template>

          <template #reorderableDropdownTemplate>
            <GcReorderableDropdown
              :grid-definitions="getGridDefinitions"
              :definitionKey="persistenceKey"
              :ref="'GcReorderableDropdown-' + persistenceKey"
              :showLoading="showLoading"
            />
          </template>

          <template #RecordTwoLines="{ data }">
            <GcRecordTwoLines
              :data="data"
              :primary="data.column['cellTemplateRecord']['primary']"
              :secondary="data.column['cellTemplateRecord']['secondary']"
            />
          </template>

          <!-- :remote-operations="setRemoteOperations" -->
          <!-- :mode="dataSourceConfig.remote ? 'virtual' : 'standard'"  -->
          <DxScrolling
            :mode="dxScrolling"
            :row-rendering-mode="dxScrolling"
            :preload-enabled="true"
          />
          <DxEditing
            :allow-updating="true"
            mode="cell"
            :select-text-on-edit-start="true"
          />

          <!-- <DxEditing :allow-updating="true" :allow-adding="true" mode="cell" /> -->
          <!-- <DxEditing
              :allow-deleting="true"
              :allow-updating="false"
              :allow-adding="true"
              mode="cell"
              newRowPosition="first"
            /> -->
          <DxMasterDetail
            :enabled="childGridColumns && childGridColumns.length > 0"
            template="masterDetailTemplate"
          />
          <template #masterDetailTemplate="{ data: lineitem }">
            <dx-data-grid
              :data-source="
                lineitem.data.InvoiceProductBatches ||
                lineitem.data.ChildDataSource
              "
              :columns="getChildGridColumns(lineitem)"
              :columnChooser="{
                enabled: false,
              }"
              :searchPanel="{
                visible: false,
              }"
              :pager="{ visible: false }"
              v-if="gridLoadingCompleted"
              :ref="getMasterDetailsRef(lineitem)"
              @editing-start="onBatchEditStarting"
              :elementAttr="{ class: 'internal-grid' }"
              @editor-preparing="onBatchEditorPreparing"
            >
              <DxEditing
                :allow-updating="true"
                :allow-deleting="false"
                mode="cell"
              />

              <template #CheckBoxTemplate="{ data }">
                <gc-grid-check-box
                  :value="
                    data.value == 'Y'
                      ? true
                      : data.value == 'N'
                      ? false
                      : data.value
                  "
                  :refKey="
                    data.data.RecordId
                      ? data.data.RecordId._value
                      : 'gc-child-grid-check-box'
                  "
                  :data="data"
                  :valueChangeCallBack="childGridCheckBoxValueChange"
                  :readOnly="
                    data.column.makeReadOnly
                      ? data.column.makeReadOnly(data)
                      : false
                  "
                  :disabled="
                    data.column.makeDisabled
                      ? data.column.makeDisabled(data)
                      : false
                  "
                ></gc-grid-check-box>
              </template>

              <template #HeaderCheckBoxTemplate="{ data }">
                <GcCheckboxHeader
                  :data="data"
                  :selectAllChecked="childGridCheckBoxValueChange"
                  :value="
                    getChildGridHeaderCheckBoxValue(
                      lineitem.data.InvoiceProductBatches ||
                        lineitem.data.ChildDataSource,
                    )
                  "
                  :ref="
                    lineitem.data.LineNo
                      ? 'cx-child-grid-' + lineitem.data.LineNo
                      : 'cx-child-grid-' + data.column.dataField
                  "
                  :id="'cx-child-grid-' + new Date().getTime()"
                  :disabled="
                    lineitem.data.IncludeDisabled != undefined
                      ? lineitem.data.IncludeDisabled
                      : false
                  "
                ></GcCheckboxHeader>
              </template>

              <template #Record="{ data }">
                <GcRecord
                  :data="data"
                  :primary="data.column['cellTemplateRecord']['primary']"
                  :secondary="data.column['cellTemplateRecord']['secondary']"
                />
              </template>

              <template #Date="{ data }">
                <GcDate
                  :date="data.data[data.column.dataField]"
                  :valueChangeCallBack="valueChangeCallBack"
                  :columnData="data.column"
                  :gridData="data"
                  :readOnly="
                    data.column.makeReadOnly
                      ? data.column.makeReadOnly(data)
                      : baseView.mode == 'review'
                  "
                  :class="
                    data.column.customClass
                      ? data.column.customClass(data, lineitem)
                      : 'none'
                  "
                  :onKeyDown="
                    (e) => {
                      childGridKeyDown(e, data, lineitem);
                    }
                  "
                />
              </template>
              <template #Decimal="{ data }">
                <GcDecimal :dataValue="data" :format="data.column.format" />
              </template>
              <template #EditableDecimal="{ data }">
                <div>
                  <div>
                    <DxNumberBox
                      :value="data.value"
                      @value-changed="batchQtyChanged($event, data, lineitem)"
                      :format="data.column.format"
                      v-bind:class="data.value < 0 ? 'avail-error' : null"
                      class="gc-grid-number-box-editor"
                      :disabled="
                        data.column.makeDisabled
                          ? data.column.makeDisabled(data) ||
                            baseView.mode == 'review'
                          : baseView.mode == 'review'
                      "
                      :readOnly="
                        data.column.makeReadOnly
                          ? data.column.makeReadOnly(data)
                          : baseView.mode == 'review'
                      "
                      @focus-in="
                        (e) => {
                          e.event.target.select();
                        }
                      "
                      @key-down="
                        (e) => {
                          childGridKeyDown(e, data, lineitem);
                        }
                      "
                    />
                  </div>
                </div>
              </template>

              <template #EditableText="{ data }">
                <div>
                  <div>
                    <DxTextBox
                      :value="data.value"
                      @value-changed="
                        childGridValueChanged($event, data, lineitem)
                      "
                      :class="
                        data.column.customClass
                          ? data.column.customClass(data, lineitem)
                          : 'gc-grid-number-box-editor'
                      "
                      :max-length="20"
                      :disabled="
                        data.column.makeDisabled
                          ? data.column.makeDisabled(data)
                          : false
                      "
                      @focus-in="
                        (e) => {
                          e.event.target.select();
                        }
                      "
                      @key-down="
                        (e) => {
                          childGridKeyDown(e, data, lineitem);
                        }
                      "
                    />
                  </div>
                </div>
              </template>
              <template #ActionDelete="{ data }">
                <div>
                  <DxButton
                    icon="trash"
                    @click="childGridValueChanged($event, data, lineitem)"
                  />
                </div>
              </template>
              <template #ActionAddNew="{ data }">
                <div>
                  <DxButton
                    icon="plus"
                    @click="childGridValueChanged($event, data, lineitem)"
                  />
                </div>
              </template>

              <template #SelectField="{ data }">
                <div>
                  <gc-field-select
                    v-if="
                      data.column.makeReadOnly
                        ? !data.column.makeReadOnly(data)
                        : !fieldItemOptions(data)[0].readOnly
                    "
                    :selectBoxOptions="fieldItemOptions(data)"
                    :acceptCustomValue="
                      data.column.makeAcceptCustomValue
                        ? data.column.makeAcceptCustomValue(data, lineitem)
                        : false
                    "
                    :valueChangeCallBack="valueChangeCallBack"
                    :gridData="data"
                    :value="data.value"
                    :showClearButton="false"
                    :setReadOnly="baseView.mode == 'review'"
                    :customFilter="
                      data.column.customFilter
                        ? data.column.customFilter(data)
                        : undefined
                    "
                    :parentRowData="lineitem"
                  ></gc-field-select>
                  <span
                    v-if="
                      data.column.makeReadOnly
                        ? data.column.makeReadOnly(data)
                        : fieldItemOptions(data)[0].readOnly
                    "
                    >{{ data.value }}</span
                  >
                </div>
              </template>
            </dx-data-grid>
          </template>
          <!-- @row-click="rowClick($event)" -->
          <DxGrouping
            :context-menu-enabled="true"
            :auto-expand-all="getAutoExpandAll"
          />
          <DxGroupPanel :visible="setGrouping" />
          <!-- or "auto" -->
          <template #Record="{ data }">
            <span v-if="data.column.hyperlink">
              <a @click="onHyperlinkClicked(data)">
                <GcRecord
                  :data="data"
                  :primary="data.column['cellTemplateRecord']['primary']"
                  :secondary="data.column['cellTemplateRecord']['secondary']"
                />
              </a>
            </span>
            <span v-else>
              <GcRecord
                :data="data"
                :primary="data.column['cellTemplateRecord']['primary']"
                :secondary="data.column['cellTemplateRecord']['secondary']"
              />
            </span>
          </template>

          <template #GcRecordCell="{ data }">
            <span v-if="data.column.hyperlink">
              <a @click="onHyperlinkClicked(data)">
                <GcRecordCell
                  :data="data"
                  :primary="data.column['cellTemplateRecord']['primary']"
                  :secondary="data.column['cellTemplateRecord']['secondary']"
                />
              </a>
            </span>
            <span v-else>
              <GcRecordCell
                :data="data"
                :primary="data.column['cellTemplateRecord']['primary']"
                :secondary="data.column['cellTemplateRecord']['secondary']"
              />
            </span>
          </template>

          <template #EditableDecimal="{ data }">
            <div>
              <div>
                <DxNumberBox
                  :value="data.value"
                  :step="0"
                  @value-changed="detailQtyChanged($event, data)"
                  :format="data.column.format"
                  class="gc-grid-number-box-editor"
                  v-bind:class="data.value < 0 ? 'avail-error' : null"
                  :disabled="
                    data.column.allowUpdate == true
                      ? false
                      : data.column.makeDisabled
                      ? data.column.makeDisabled(data) ||
                        baseView.mode == 'review'
                      : baseView.mode == 'review'
                  "
                  :min="
                    data.column.minmax
                      ? data.column.minmax.min != undefined
                        ? data.column.minmax.min
                        : undefined
                      : undefined
                  "
                  :max="
                    data.column.minmax
                      ? data.column.minmax.max
                        ? data.column.minmax.max
                        : undefined
                      : undefined
                  "
                  :readOnly="
                    data.column.makeReadOnly
                      ? data.column.makeReadOnly(data)
                      : baseView.mode == 'review'
                  "
                  @focus-in="
                    (e) => {
                      e.event.target.select();
                    }
                  "
                  @key-down="
                    data.column.onKeyDown
                      ? data.column.onKeyDown($event, data)
                      : undefined
                  "
                  @key-up="
                    (e) => {
                      data.column.editorOptions &&
                      data.column.editorOptions.keyUp
                        ? data.column.editorOptions.keyUp(e, data)
                        : undefined;
                    }
                  "
                />
              </div>
            </div>
          </template>
          <template #Date="{ data }">
            <GcDate
              :date="data.data[data.column.dataField]"
              :valueChangeCallBack="valueChangeCallBack"
              :columnData="data.column"
              :gridData="data"
              :readOnly="
                data.column.makeReadOnly
                  ? data.column.makeReadOnly(data)
                  : baseView.mode == 'review'
              "
            />
          </template>
          <template #Decimal="{ data }">
            <GcDecimal :dataValue="data" :format="data.column.format" />
          </template>
          <template #Status="{ data }">
            <GcStatusChip
              :status="data.data[data.column.dataField]"
              v-if="data.data[data.column.dataField]"
              :customBackGroundColor="
                data.column.customBackGroundColor
                  ? data.column.customBackGroundColor
                  : undefined
              "
              :data="data.data"
            />
          </template>

          <template #StatusYesNo="{ data }">
            <GcStatusYesNo
              :status="data.data[data.column.dataField]"
              v-if="data.data[data.column.dataField]"
              :data="data.data"
            />
          </template>
          <template #Hyperlink="{ data }">
            <span
              v-if="
                data.column.hyperlink.zeroClickable == true ||
                (data.data[data.column.dataField] != 0 &&
                  data.data[data.column.dataField] != '')
              "
            >
              <a @click="onHyperlinkClicked(data)">
                <span v-if="data.column.format">
                  <GcDecimal :dataValue="data" :format="data.column.format" />
                </span>
                <span v-else>{{ data.text }}</span>
              </a>
            </span>
            <span v-else>
              <span v-if="data.column.format">
                <GcDecimal :dataValue="data" :format="data.column.format" />
              </span>
              <span v-else>{{ data.text }}</span>
            </span>
          </template>

          <template #HyperLinkText="{ data }">
            <span v-if="data.column.activeHyperLink(data)">
              <a @click="data.column.customHyperLink(data)">
                {{ data.displayValue }}
              </a>
            </span>
            <span v-else>
              <span
                v-if="
                  data.column['cellTemplateRecord']['primary'] &&
                  data.column['cellTemplateRecord']['secondary']
                "
              >
                <GcRecord
                  :data="data"
                  :primary="data.column['cellTemplateRecord']['primary']"
                  :secondary="data.column['cellTemplateRecord']['secondary']"
                />
              </span>
              <span v-else>{{ data.displayValue }}</span>
            </span>
          </template>

          <template #ActiveStatus="{ data }">
            <GcInactive :inactive="data.data[data.column.dataField]" />
          </template>

          <template #menu-cell-template="{ data }">
            <GcMenuCellTemplate
              class="invoice-print-btn"
              :data="data"
              :menuOptions="data.column.ellipsisMenu"
              :onItemClickCallBack="onItemClickCallBack"
              :visible="data.column.visible"
              :disabled="
                data.column.makeDisabled
                  ? data.column.makeDisabled(data)
                  : false
              "
            />
          </template>

          <template #RadioTemplate="{ data }">
            <GcFieldRadio
              :value="data.data.IsDefault"
              :data="data"
              :valueChangeCallBack="radioValueChange"
              :disabled="
                data.column.makeDisabled
                  ? data.column.makeDisabled(data)
                  : false
              "
            />
          </template>

          <template #CheckBoxTemplate="{ data }">
            <gc-grid-check-box
              :value="
                data.value == 'Y'
                  ? true
                  : data.value == 'N'
                  ? false
                  : data.value
              "
              :refKey="
                data.data.RecordId
                  ? data.data.RecordId._value
                  : 'gc-grid-check-box'
              "
              :data="data"
              :valueChangeCallBack="checkBoxValueChange"
              :readOnly="
                data.column.makeReadOnly
                  ? data.column.makeReadOnly(data)
                  : false
              "
              :disabled="
                data.column.makeDisabled
                  ? data.column.makeDisabled(data)
                  : false
              "
            ></gc-grid-check-box>
          </template>

          <template #HeaderCheckBoxTemplate="{ data }">
            <GcCheckboxHeader
              :data="data"
              :selectAllChecked="checkBoxValueChange"
              :value="data.column.defaultValue"
              :ref="'cx-' + data.column.dataField"
              :id="'cx-' + new Date().getTime()"
              :readOnly="
                data.column.makeReadOnly
                  ? data.column.makeReadOnly(data)
                  : false
              "
            ></GcCheckboxHeader>
          </template>

          <template #SelectField="{ data }">
            <div>
              <gc-field-select
                v-if="
                  data.column.makeReadOnly
                    ? !data.column.makeReadOnly(data)
                    : !fieldItemOptions(data)[0].readOnly
                "
                :selectBoxOptions="fieldItemOptions(data)"
                :valueChangeCallBack="valueChangeCallBack"
                :gridData="data"
                :value="data.value"
                :showClearButton="
                  fieldItemOptions(data) &&
                  fieldItemOptions(data)[0].editorOptions &&
                  fieldItemOptions(data)[0].editorOptions.showClearButton
                    ? fieldItemOptions(data)[0].editorOptions.showClearButton
                    : false
                "
                :setReadOnly="
                  data.column.makeReadOnly
                    ? data.column.makeReadOnly(data)
                    : baseView.mode == 'review'
                "
                :customFilter="
                  data.column.customFilter
                    ? data.column.customFilter(data)
                    : undefined
                "
              ></gc-field-select>
              <span
                v-if="
                  data.column.makeReadOnly
                    ? data.column.makeReadOnly(data)
                    : fieldItemOptions(data)[0].readOnly
                "
              >
                <span
                  v-if="
                    data.column.displayValue &&
                    !data.column.displayValue(data) &&
                    data.column['cellTemplateRecord']
                  "
                >
                  <GcRecord
                    :data="data"
                    :primary="data.column['cellTemplateRecord']['primary']"
                    :secondary="data.column['cellTemplateRecord']['secondary']"
                /></span>
                <span v-else>
                  {{
                    data.column.displayValue
                      ? data.column.displayValue(data)
                      : data.value
                  }}</span
                >
              </span>
            </div>
          </template>

          <template #Custom="{ data }">
            <span> {{ data.column.displayValue(data.data) }} </span>
          </template>

          <DxSummary
            v-if="getGrandTotals || getSubTotals"
            :calculate-custom-summary="calculateCustomSummary"
          >
            <DxTotalItem
              v-for="grandTotalItem in getGrandTotals"
              v-bind:key="
                grandTotalItem['fieldName'] +
                '-' +
                grandTotalItem['value-format']
              "
              :column="grandTotalItem['column']"
              :summary-type="grandTotalItem['summary-type']"
              :value-format="grandTotalItem['value-format']"
              :name="grandTotalItem['fieldName']"
              display-format="{0}"
            />
            <DxTotalItem
              v-for="totalItem in getCustomSummary"
              v-bind:key="totalItem['id'] + '-custom-total'"
              :summary-type="totalItem['summary-type']"
              :value-format="totalItem['value-format']"
              :name="
                dataSourceConfig.local == true
                  ? totalItem['fieldName']
                  : totalItem['name']
              "
              display-format="{0}"
              :show-in-column="totalItem['dataField']"
            />
            <DxGroupItem
              v-for="subTotalItem in getSubTotals"
              v-bind:key="subTotalItem['fieldName'] + '-sum'"
              :column="subTotalItem['column']"
              :summary-type="subTotalItem['summary-type']"
              :value-format="subTotalItem['value-format']"
              display-format="{0}"
              :show-in-group-footer="false"
              :align-by-column="true"
              :show-in-column="subTotalItem['dataField']"
            />

            <DxGroupItem
              v-for="item in getCustomSummary"
              :key="item['id'] + '-group'"
              :name="
                dataSourceConfig.local == true
                  ? item['fieldName']
                  : item['name']
              "
              :column="
                dataSourceConfig.local == true ? undefined : item['column']
              "
              :summary-type="item['summary-type']"
              :show-in-group-footer="false"
              :value-format="item['value-format']"
              display-format="{0}"
              :align-by-column="true"
              :show-in-column="item['dataField']"
            />

            <!-- :show-in-group-footer="item['show-in-group-footer']" -->
          </DxSummary>

          <template #header-in-toolbar="{ data }">
            <div class="informer">
              <GcHeaderContentDynamic
                :baseView="baseView"
                :primaryLabel="toolbarHeader['primary']"
                :secondaryLabel="toolbarHeader['secondary']"
                :viewMode="'popup'"
              />
            </div>
          </template>

          <template #print-cell-template="{ data }">
            <GcPrint
              :data="data"
              :showLoading="showLoading"
              :dataField="data.column.dataField"
              :refresh="gridRepaint"
            />
            <!-- <GcPrint :data="data" :showLoading="showLoading" :dataField="'CustomerTransactionNumber'" :refresh="gridRepaint"/> -->
          </template>
          <template #email-cell-template="{ data }">
            <GcEmail
              :data="data"
              :showLoading="showLoading"
              :dataField="data.column.reportDataField"
              :gridColumns="gridColumns"
              :baseView="baseView"
            />
            <!-- :refresh="gridRepaint" -->
          </template>
          <template #pdf-view-cell-template="{ data }">
            <GcPrintPreview
              :data="data"
              :showLoading="showLoading"
              :dataField="data.column.reportDataField"
              :gridColumns="gridColumns"
            />
            <!-- <GcPrintPreview :data="data" :showLoading="showLoading" :dataField="'CustomerTransactionNumber'"/> -->
          </template>

          <template #delete-cell-template="{ data }">
            <GcRecordDelete
              :data="data"
              :showLoading="showLoading"
              :dataField="data.column.dataField"
              :refresh="gridRepaint"
            />
            <!-- <GcPrint :data="data" :showLoading="showLoading" :dataField="'CustomerTransactionNumber'" :refresh="gridRepaint"/> -->
          </template>

          <template #group-cell-template="{ data }">
            <div class="informer">
              <span>{{ formatGroupCellDisplay(data) }}</span>
            </div>
          </template>

          <template #custom-cell-template="{ data }">
            <div class="informer">
              <span>{{
                data.column.customCellDataField
                  ? data.data[data.column.customCellDataField]
                  : data.displayValue
              }}</span>
            </div>
          </template>

          <template #EditableTextArea="{ data }">
            <div>
              <DxTextArea
                v-if="baseView.mode != 'review' || data.column.allowUpdate"
                :value="data.data.Comment"
                :disabled="
                  baseView.mode == 'review' && data.column.allowUpdate
                    ? data.column.makeDisabled
                      ? data.column.makeDisabled(data)
                      : true
                    : data.column.makeDisabled
                    ? data.column.makeDisabled(data) ||
                      baseView.mode == 'review'
                    : baseView.mode == 'review'
                "
                @value-changed="valueChangeCallBack($event, data)"
                class="gc-grid-number-box-editor"
                @key-down="
                  data.column.onKeyDown
                    ? data.column.onKeyDown($event, data)
                    : undefined
                "
                :maxLength="
                  data.column.editorOptions &&
                  data.column.editorOptions.maxLength
                    ? data.column.editorOptions.maxLength
                    : null
                "
              />
              <span v-else> {{ data.displayValue }} </span>
            </div>
          </template>

          <!-- not master details  -->
          <template #EditableText="{ data }">
            <div>
              <DxTextBox
                v-if="baseView.mode != 'review' || data.column.allowUpdate"
                :value="data.data[data.column.dataField]"
                class="gc-grid-number-box-editor"
                :disabled="
                  baseView.mode == 'review' && data.column.allowUpdate
                    ? data.column.makeDisabled
                      ? data.column.makeDisabled(data)
                      : true
                    : data.column.makeDisabled
                    ? data.column.makeDisabled(data) ||
                      baseView.mode == 'review'
                    : baseView.mode == 'review'
                "
                @value-changed="valueChangeCallBack($event, data)"
                @key-down="
                  data.column.onKeyDown
                    ? data.column.onKeyDown($event, data)
                    : undefined
                "
              />
              <span v-else> {{ data.displayValue }} </span>
            </div>
          </template>
          <template #ScrollView="{ data }">
            <DxScrollView
              class="scrollable-board"
              direction="both"
              show-scrollbar="always"
              :scroll-by-content="true"
              :scroll-by-thumb="true"
              :height="40"
            >
              {{ data.displayValue }}
            </DxScrollView>
          </template>

          <template #ActionDelete="{ data }">
            <div>
              <DxButton
                icon="trash"
                @click="valueChangeCallBack($event, data)"
                :hint="'Delete'"
                :disabled="
                  data.column.makeDisabled
                    ? data.column.makeDisabled(data)
                    : false
                "
              />
            </div>
          </template>
          <template #ActionAddNew="{ data }">
            <div>
              <DxButton
                icon="plus"
                @click="valueChangeCallBack($event, data)"
                :hint="'Add New'"
              />
            </div>
          </template>
          <template #ActionCopy="{ data }">
            <div>
              <DxButton
                icon="copy"
                @click="valueChangeCallBack($event, data)"
                :hint="'Copy Line'"
                :disabled="
                  data.column.makeDisabled
                    ? data.column.makeDisabled(data)
                    : false
                "
              />
            </div>
          </template>

          <template #download-cell-template="{ data }">
            <div>
              <DxButton
                icon="fa-solid fa-file-arrow-down"
                :disabled="data.column.makeDisabled(data)"
                @click="valueChangeCallBack($event, data)"
              />
            </div>
          </template>
        </dx-data-grid>
      </template>
      <template #rightContent>
        <gc-filter-panel
          v-if="getFilterFormHeight && gridColumns.length > 0 && gridLoaded"
          :toolbar="filterToolbar"
          :formItemData="formItemData"
          :setGridPanelFilter="setGridPanelFilter"
          :gridFoolter="showFooter"
          :persistenceKey="persistenceKey"
          :showLoading="showLoading"
          :getGridInstance="getGridInstance"
          :from="id"
          :ref="'gc-filter-panel'"
          :heightAdjustment="filterHeightAdjustment"
        >
        </gc-filter-panel>
      </template>
    </gc-filter-split-view>

    <GcPopup
      v-if="formPopupDataModel"
      :popup-visible="formPopupVisible"
      :popup-title="formPopupTitle"
      :back-button-function="formPopupBackButtonClick"
      :popupHeight="300"
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
    >
      <div class="css-v2 gc-popup-form">
        <GcForm
          :formOptions="formOptions"
          :formItems="formPopupItems"
          :formHeight="180"
          :isNormal="true"
          :data-model="formPopupDataModel"
          :formMode="baseView.mode"
          v-if="formPopupItems"
          :fromFrom="'gc-data-grid-form-2'"
        ></GcForm>
      </div>
    </GcPopup>

    <DxLoadPanel
      :position="loadingPosition"
      :visible.sync="loadingVisible"
      :show-indicator="true"
      :show-pane="true"
      :shading="true"
      :hide-on-outside-click="false"
      shading-color="rgba(0,0,0,0.3)"
    />

    <GcPopupValidationSummary
      :showPopup.sync="validationSummaryVisible"
      :title="'Validation Errors'"
      :isXSmall="isXSmall"
      :items.sync="validationItems"
    ></GcPopupValidationSummary>

    <gc-popup
      :popup-visible="auditPopupVisible"
      popup-title="Audit History"
      :back-button-function="formPopupBackButtonClick"
      :popup-height="200"
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
    >
      <div class="css-v2 gc-popup-form">
        <gc-form
          :formOptions="formOptions"
          :formItems="gridToolbar.auditItems"
          :isNormal="true"
          :data-model="auditModel"
          v-if="gridToolbar.auditItems"
          :fromFrom="'gc-data-grid-form-1'"
        ></gc-form>
      </div>
    </gc-popup>

    <GcPopupReorderLayout
      :visible.sync="getVisibleReorderSavePopup"
      :definitionKey="persistenceKey"
      :showLoading="showLoading"
      ref="reorderSavePopup"
      v-if="getVisibleReorderSavePopup"
    />
  </div>
</template>

<script>
import ApiService from "@/_services/api/api.service";
import GcFilterPanel from "../components/gc-filter-panel";
import GcRecord from "../components/gc-record";
import GcDecimal from "../components/gc-decimal";
import GcDate from "../components/gc-date";
import GcStatusChip from "../components/gc-status-chip";
import GcStatusYesNo from "../components/gc-status-chip-yes-no";
import GcReorderableDropdown from "./data-grid/gc-reorderable-dropdown.vue";
import { DxNumberBox } from "devextreme-vue/number-box";
import {
  getGlobalField,
  getDecimalFormat,
  getDefaultUserSettings,
  getDefaultCustomerSettings,
} from "@/_store/helpers";
import { mapGetters } from "vuex";
import Vue from "vue";
import { DxMasterDetail } from "devextreme-vue/data-grid";
import RouteMixin from "@/_mixins/route.mixin";
import GcPopupReorderLayout from "../popups/data-grid/gc-popup-reorder-layout.vue";

function logDev() {
  // eslint-disable-next-line no-console
  console.log("DataGrid  >>> ", arguments);
}

import {
  DxSummary,
  DxTotalItem,
  DxStateStoring,
  DxExport,
  DxGrouping,
  DxGroupPanel,
  DxGroupItem,
} from "devextreme-vue/data-grid";
// import { SplitViewService } from "../_services/api/templates/split-view.services";

import * as AspNetData from "devextreme-aspnet-data-nojquery";
import { TokenStorage } from "@/_services/storage";

import FormMixin from "@/_mixins/form.mixin";

// import { GridReportServiceV2 } from "../_services/api/reports/grid-report.v2.service";
import appConfig from "../app-config";
import { CommonStorage, secureStorage } from "../_services/storage";
import { DataGridState } from "../_models/data-grid-state";
import GcRecordTwoLines from "./gc-record-two-lines.vue";

import { exportGrid } from "../_helpers/data-grid/exporter";

let customAggregateCollection = {};
let dataGridViewsSelectBox = undefined;

// var replacer = function (key, value) {
//   if (this[key] instanceof Date) {
//     return this[key].toUTCString();
//   }

//   return value;
// };

export default {
  mixins: [FormMixin, RouteMixin],
  props: {
    dxScrolling: {
      type: String,
      default: "virtual",
    },
    persistenceKey: {
      type: String,
    },
    id: {
      type: String,
      required: true,
    },
    /**
     * Data grid toolbar configurations
     */
    gridToolbar: {
      type: Object,
      default: () => {},
    },
    /**
     * data grid data source configuratio
     */
    dataSourceConfig: {
      type: Object,
      default: () => {},
    },
    /**
     * data grid columns definition
     */
    columns: {
      type: Array,
      default: () => [],
    },
    childGridColumns: {
      type: [Function, Array],
      default: () => {},
    },
    valueChangeListners: {
      type: Array,
      default: () => [],
    },

    grouping: {
      type: Boolean,
      default: false,
    },
    isEditableGrid: {
      type: Boolean,
      default: false,
    },
    isLocalDataSource: {
      type: Boolean,
      default: false,
    },
    export: {
      type: Boolean,
      default: false,
    },
    summary: {
      type: Boolean,
      default: false,
    },
    padColumn: {
      type: Boolean,
      default: false,
    },
    exportFileName: {
      type: String,
      default: "Data Export -" + new Date(),
    },
    rowClick: {
      type: Function,
      default: () => {},
    },
    updateIsDefault: {
      type: [Boolean, String],
      default: undefined,
    },
    showFooter: {
      type: Boolean,
      default: false,
    },
    gridOptions: {
      type: Object,
      default: () => {},
    },
    autoExpandAll: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "grid-report",
    },
    gridHeightOverWrite: {
      type: Number,
      default: undefined,
    },
    paging: {
      type: Boolean,
      default: true,
    },
    toolbarHeader: {
      type: Object,
      default: () => {},
    },
    showSave: {
      type: Boolean,
      default: false,
    },
    dataModel: {
      type: Object,
      default: () => {},
    },
    saveCallBack: {
      type: Function,
      default: () => {},
    },
    rowRemoved: {
      type: Function,
      default: () => {},
    },
    elementAttrClass: {
      type: String,
      default: "gc-data-grid",
    },
    onRowDblClick: {
      type: Function,
      default: () => {},
    },
    heightPadding: {
      type: Number,
      default: 0,
    },
    rowAlternationEnabled: {
      type: Boolean,
      default: true,
    },
    filterHeightAdjustment: {
      type: Number,
      default: 0,
    },
    getSelectedRowKeys: {
      type: Array,
      default: () => [],
    },
    defaultUserSettings: {
      type: Boolean,
      default: true,
    },
    keyExpr: {
      type: String,
    },
    saveGridLayout: {
      type: Boolean,
      default: false,
    },
    savedGridLayout: {
      type: Object,
      default: () => {
        return {
          GridKey: null,
          TemplateName: null,
          TemplateType: "Me",
        };
      },
    },
    // ------
  },
  components: {
    GcFilterPanel,
    GcRecord,
    GcDecimal,
    GcDate,
    GcStatusChip,
    GcStatusYesNo,
    DxSummary,
    DxTotalItem,
    DxGroupItem,
    DxExport,
    DxGrouping,
    DxGroupPanel,
    DxMasterDetail,
    DxNumberBox,
    DxStateStoring,
    GcRecordTwoLines,
    GcReorderableDropdown,
    GcPopupReorderLayout,
  },
  data() {
    //
    return {
      filters: [],
      auditPopupVisible: false,
      itemsMutationIndex: 0,
      localDs: [],
      showLeftContainer: true,
      showRightContainer: false,
      filterToolbar: {
        close: {
          icon: "showpanel",
          onClick: () => {
            this.showRightContainer = !this.showRightContainer;
            var item = document.getElementById("filter-btn");
            item.classList.remove("dx-state-invisible");

            setTimeout(() => {
              this.reSizeGrid();
            }, 50);
          },
        },
        filterOnEnter: this.gridToolbar.filterOnEnter
          ? this.gridToolbar.filterOnEnter
          : false,
      },
      filterFormHeight: undefined,
      dataGridForNoData: undefined,
      gridPanelFilter: [],
      proceedDataLoading: false,
      formPopupVisible: false,
      formPopupTitle: undefined,
      formOptions: {
        gcLabelLocation: "left",
      },
      formPopupItems: [],
      formPopupDataModel: undefined,
      gridDataSourceItems: [],

      loadingPosition: { of: "#container-wrapper" },
      loadingVisible: false,
      dataGridView: undefined,
      validationSummaryVisible: false,
      validationItems: [],
      gridLoaded: false,
      previewPdfs: [],
      emailRecords: [],
      currentSearchText: undefined,
      scrollingOffSet: undefined,
      viewLocalItems: false,
      initiateDataLoading: false,
      defaultUpdated: false,
      setAutoExpand: undefined,
      groupExpand: false,
      totalItemCount: 0,
      countIntervalID: undefined,
      originalColumns: [],
      visibleReorderSavePopup: false,
    };
  },
  async mounted() {
    this.originalColumns = JSON.parse(JSON.stringify(this.columns));
    if (
      (this.id == "transaction-list-grid" ||
        this.id == "grid-report-grid" ||
        this.id == "model") &&
      this.gridToolbar.openFilter &&
      this.gridToolbar.openFilter == true
    ) {
      this.showRightContainer = true;
      setTimeout(() => {
        if (this.id == "transaction-list-grid")
          this.$store.dispatch("hotKey/setHotKeyFilterFocus", true);
      }, 250);
    }

    if (
      this.gridToolbar.openFilterByDefault &&
      this.gridToolbar.openFilterByDefault == true
    )
      this.showRightContainer = true;

    this.configureDefaultGridOptions();
    this.initiateDataLoading =
      (await this.gridColumns.filter((x) => x.filterDefaultValue).length) == 0
        ? true
        : false;

    if (this.dataSourceConfig && this.dataSourceConfig.remote) {
      var savedFilters = JSON.parse(
        CommonStorage.getItems("filter-panel-" + this.persistenceKey),
      );
      if (savedFilters && savedFilters.length > 0)
        this.initiateDataLoading = false;
    }
  },
  computed: {
    getVisibleReorderSavePopup: {
      get() {
        return this.visibleReorderSavePopup;
      },
      set(value) {
        this.visibleReorderSavePopup = value;
      },
    },
    ...mapGetters({
      getGridViewDefinitionByKey:
        "gridViewDefinition/getGridViewDefinitionByKey",
    }),
    ...mapGetters({
      getDefinitionWithSameKeyAndName:
        "gridViewDefinition/getDefinitionWithSameKeyAndName",
    }),
    getAutoExpandAll() {
      if (this.setAutoExpand != undefined) return this.setAutoExpand;
      else return this.autoExpandAll;
    },
    getSelectionFilter() {
      if (
        this.gridOptions &&
        this.gridOptions.options &&
        this.gridOptions.options.selectionFilter
      ) {
        return this.gridOptions.options.selectionFilter;
      } else return [];
    },
    dataSourceConfigComputed() {
      if (this.initiateDataLoading) {
        return this.originalDataSourceConfig;
      } else {
        return [];
      }
    },
    originalDataSourceConfig() {
      return this.isLocalDataSource
        ? this.localDs
        : this.dataSourceConfig.remote
        ? this.dataSourceConfig.filter &&
          this.dataSourceConfig.filter.length > 0
          ? []
          : this.gridRemoteDataSource
        : this.gridDataSource;
    },
    // getSearchText() {
    //   if (CommonStorage.getItems("searchText")) {
    //     return CommonStorage.getItems("searchText");
    //   } else {
    //     return "";
    //   }
    // },
    getPersistenceKey() {
      return this.persistenceKey + "_" + appConfig.VUE_APP_COOKIE_NAME;
    },
    auditModel() {
      if (this.gridToolbar.audit)
        return {
          FormattedDateCreated: `${this.dataModel.CreatedBy} ${
            this.dataModel.DateCreated
              ? this.dataModel.DateCreated.toFriendlyDBDateTimeString()
              : null
          }`,
          FormattedDateChanged: this.dataModel.ChangedBy
            ? `${this.dataModel.ChangedBy} ${
                this.dataModel.DateChanged
                  ? this.dataModel.DateChanged.toFriendlyDBDateTimeString()
                  : null
              }`
            : null,
        };
      else return {};
    },
    setRemoteOperations() {
      if (this.dataSourceConfig.local == true) {
        return {
          filtering: true,
          grouping: false,
          summary: false,
          groupPaging: false,
          paging: false,
        };
      } else if (this.dataSourceConfig.allowGrouping == false) {
        if (this.dataSourceConfig.serverPaging == false)
          return { paging: false };
        else return this.dataSourceConfig.remote ? true : "auto";
      } else if (typeof this.dataSourceConfig.remote === "object") {
        return this.dataSourceConfig.remote;
      } else return this.dataSourceConfig.remote ? true : "auto";
    },
    setGrouping() {
      if (this.dataSourceConfig.allowGrouping == false) return false;
      else return true;
    },
    ...mapGetters({
      applicationMode: "profile/applicationMode",
    }),
    ...mapGetters({ gridHeight: "ui/getHeightForDataGrid" }),
    ...mapGetters({ checkGridNoData: "ui/getCheckGridNoData" }),

    ...mapGetters({ headerFormHeight: "ui/getHeaderFormHeight" }),
    ...mapGetters({ gridExpand: "ui/getGridExpand" }),
    ...mapGetters({ viewRouted: "ui/getViewRouted" }),
    ...mapGetters({ updateGridOnDefault: "ui/getUpdateGridOnDefault" }),
    ...mapGetters({ updateIsDefaultCode: "ui/getUpdateIsDefaultCode" }),
    ...mapGetters({ reviewDataSource: "dataContext/getReviewDataSource" }),
    ...mapGetters({
      isAdvanceFilterApplied: "dataContext/getAdvanceFilterApplied",
    }),
    ...mapGetters({ dataViewType: "dataContext/getDataViewType" }),
    ...mapGetters({
      reportPdfScreens: "reportPdfPreview/getReportPreviewScreens",
    }),
    ...mapGetters({
      companyName: "profile/companyName",
    }),
    getGridHeight() {
      if (this.gridHeightOverWrite != null) {
        return this.gridHeightOverWrite;
      }
      if (this.headerFormHeight)
        return (
          this.gridHeight -
          (this.gridExpand ? 6 : this.headerFormHeight) -
          (this.showFooter ? 50 : 0)
        );
      else
        return (
          this.gridHeight -
          (this.showFooter ? 50 : 0) -
          (this.showSave ? 75 : 0)
        );
      // else return this.gridHeight - (this.showFooter ? 50 : this.applicationMode == 'GcorpRoam' ? 15 : 0);
    },
    gridRef() {
      return "gc-dat-grid" + this.id;
    },
    gridLoadingCompleted() {
      // return true;
      return this.gridLoaded;
    },
    gridRemoteDataSource() {
      return AspNetData.createStore({
        loadUrl:
          appConfig.VUE_APP_ROOT_API +
          "/apiv2/" +
          this.dataSourceConfig.endpoint,
        loadParams: {
          filter:
            this.dataSourceConfig &&
            this.dataSourceConfig.filter &&
            this.dataSourceConfig.filter.length > 0
              ? JSON.stringify(this.finalFilterValues)
              : undefined,
          select:
            this.dataSourceConfig && this.dataSourceConfig.select
              ? JSON.stringify(this.dataSourceConfig.select)
              : undefined,
        },
        onBeforeSend: function (method, request) {
          request.headers = {
            Authorization: `Bearer ${TokenStorage.getToken()}`,
            "Content-Type": "application/json",
            "x-tenant-id": TokenStorage.getTenant(),
          };
        },
      });
    },
    gridDataSource() {
      if (!this.proceedDataLoading) return null;

      if (this.dataGridView == "review") {
        this.$store.dispatch("dataContext/setDataViewType", "review");
        // var reviewValue = this.gridOptions.review.filter((x) => {
        //   return x.value == "review";
        // });

        if (this.gridOptions.dataGridViews) {
          var reviewType = this.gridOptions.dataGridViews.filter((x) => {
            return x.value == "review";
          });

          if (reviewType) {
            if (reviewType[0].dataSource.postProcessCallback)
              return reviewType[0].dataSource.postProcessCallback(
                this.reviewDataSource,
              );
            else return this.reviewDataSource;
          } // else return this.reviewDataSource;
        } // else return this.reviewDataSource;
      }

      if (this.gridOptions && this.gridOptions.dataGridViews) {
        var defaultValue = this.gridOptions.dataGridViews.filter((x) => {
          if (x.default && !this.dataGridView) return x.value;
          else if (x.value == this.dataGridView) return x;
        });

        this.$store.dispatch(
          "dataContext/setDataViewType",
          defaultValue[0].value,
        );

        if (defaultValue[0].value == "review") {
          // this.dataGridView = "review";
          return this.reviewDataSource;
        }

        if (
          defaultValue &&
          defaultValue[0].dataSource &&
          defaultValue[0].dataSource.localDataList
        ) {
          this.setViewLocalItems(true);
          // return defaultValue[0].dataSource.items;

          if (defaultValue[0].dataSource.postProcessCallback) {
            return defaultValue[0].dataSource.postProcessCallback(
              defaultValue[0].dataSource.items,
            );
          } else {
            return defaultValue[0].dataSource.items;
          }
        } else this.setViewLocalItems(false);

        if (defaultValue && defaultValue[0].dataSource) {
          var dSource = defaultValue[0].dataSource;
          let ds = ApiService.createDataSource("api/" + dSource.endpoint, {
            count: true,
            preventPagination:
              dSource.serverPaging !== undefined ? dSource.serverPaging : true,
            expand: dSource.expand,
            orderby: dSource.orderby,
            postProcess: dSource.postProcessCallback
              ? dSource.postProcessCallback
              : (data) => data,
            select: dSource.select ? dSource.select : undefined,
            filter: dSource.filter ? dSource.filter : null,
            key: dSource.key ? dSource.key : null,
            keyType: dSource.keyType ? dSource.keyType : null,
            fieldTypes: dSource.fieldTypes ? dSource.fieldTypes : null,
          });
          if (this.finalFilterValues && this.finalFilterValues.length > 0) {
            ds.filter(this.finalFilterValues);
          }

          return ds;
        } else return [];
      } else {
        let ds = [];
        if (this.dataSourceConfig.endpoint)
          ds = ApiService.createDataSource(
            "api/" + this.dataSourceConfig.endpoint,
            {
              count: true,
              preventPagination:
                this.dataSourceConfig.serverPaging !== undefined
                  ? !this.dataSourceConfig.serverPaging
                  : true,
              expand: this.dataSourceConfig.expand,
              postProcess: this.dataSourceConfig.postProcessCallback
                ? this.dataSourceConfig.postProcessCallback
                : (data) => data,
              select: this.dataSourceConfig.select
                ? this.dataSourceConfig.select
                : undefined,
              filter:
                this.finalFilterValues && this.finalFilterValues.length > 0
                  ? this.finalFilterValues
                  : this.dataSourceConfig.filter &&
                    this.dataSourceConfig.filter.length > 0
                  ? this.dataSourceConfig.filter
                  : null,

              key: this.dataSourceConfig.key ? this.dataSourceConfig.key : null,
              keyType: this.dataSourceConfig.keyType
                ? this.dataSourceConfig.keyType
                : null,
              orderby: this.dataSourceConfig.orderby,
              sort: this.dataSourceConfig.sort,
            },
          );

        // if (this.finalFilterValues && this.finalFilterValues.length > 0) {
        //   console.log("* F", this.finalFilterValues);
        //   return ds.filter(this.finalFilterValues);
        // } else

        logDev("gridDataSource", ds);
        return ds;
      }
    },
    gridDefaultFilter() {
      if (this.gridOptions && this.gridOptions.dataGridViews) {
        var defaultValue = this.gridOptions.dataGridViews.filter((x) => {
          if (x.default && !this.dataGridView) return x.value;
          else if (x.value == this.dataGridView) return x;
        });

        if (defaultValue) {
          return defaultValue[0].dataSource.filter;
        } else return undefined;
      } else return this.dataSourceConfig.filter;
    },

    finalFilterValues() {
      let filterCollection =
        this.gridPanelFilter && this.gridPanelFilter.length > 0
          ? [...this.gridPanelFilter]
          : [];
      if (filterCollection.length > 0) {
        if (this.gridDefaultFilter) {
          if (
            filterCollection.length > 0 &&
            filterCollection[filterCollection.length - 1] != "and"
          ) {
            filterCollection.push("and");
          }

          if (typeof this.gridDefaultFilter === "string") {
            filterCollection.push(this.gridDefaultFilter);
          } else {
            this.gridDefaultFilter.forEach((element) => {
              filterCollection.push(element);
            });
          }
        }
      } else {
        filterCollection = this.gridDefaultFilter;
      }
      this.setFilterFinalValue(filterCollection);

      return filterCollection;
    },

    formItemData() {
      return this.columns
        .map((c) => {
          if (c.filterIndex != undefined) {
            return c;
          }
        })
        .filter((x) => x != null)
        .sort(function (a, b) {
          return a.filterIndex - b.filterIndex;
        });
    },
    getGrandTotals() {
      return this.getAllColumns(this.columns)
        .map((c) => {
          if (c.grandTotal == "SUM") {
            let globalField = { ...getGlobalField(c.screenField) };
            if (globalField) {
              globalField["column"] = globalField.dataField; // this.getColumnName(globalField);
              globalField["value-format"] = this.getDecimalFormatFromHelper(
                c.format ? c.format : globalField["format"],
              );
              globalField["summary-type"] = "sum";
            }
            return globalField;
          } else if (c.grandTotal == "AVG") {
            let globalField = { ...getGlobalField(c.screenField) };
            if (globalField) {
              globalField["column"] = globalField.dataField; // this.getColumnName(globalField);
              globalField["value-format"] = this.getDecimalFormatFromHelper(
                c.format ? c.format : globalField["format"],
              );
              globalField["summary-type"] = "avg";
            }
            return globalField;
          } else if (c.grandTotal == "MAX") {
            let globalField = { ...getGlobalField(c.screenField) };
            if (globalField) {
              globalField["column"] = globalField.dataField;
              if (globalField.type == "Date") {
                globalField["value-format"] = "dd MMM yyyy";
              } else {
                globalField["value-format"] = this.getDecimalFormatFromHelper(
                  c.format ? c.format : globalField["format"],
                );
              }
              globalField["summary-type"] = "max";
            }
            return globalField;
          } else if (c.grandTotal == "COUNT") {
            let globalField = { ...getGlobalField(c.screenField) };
            if (globalField) {
              globalField["column"] = globalField.dataField; // this.getColumnName(globalField);
              (globalField["value-format"] = "##,##0"),
                (globalField["summary-type"] = "count");
            }
            return globalField;
          }
        })
        .filter((x) => x != null);
    },
    getCustomSummary() {
      return this.columns
        .map((c, index) => {
          if (c.subTotal == "CUSTOM") {
            let globalField = { ...getGlobalField(c.screenField) };

            if (globalField) {
              globalField["id"] = index;
              if (!c.customSummary.clientSide) {
                globalField["column"] = globalField.dataField; // this.getColumnName(globalField);
              }

              globalField["value-format"] = this.getDecimalFormatFromHelper(
                c.format ? c.format : globalField["format"],
              );
              globalField["summary-type"] = c.customSummary.aggregator;
            }
            return globalField;
          }
        })
        .filter((x) => x != null);
    },
    customSummaryFields() {
      return this.columns
        .map((c) => {
          if (c.subTotal == "CUSTOM") {
            let globalField = { ...getGlobalField(c.screenField) };
            let customField = {};

            if (globalField) {
              if (c.customSummary.clientSide) {
                customField[globalField.dataField] = c.customSummary.params;
              }

              return customField;
            }
          }
        })
        .filter((x) => x != null)
        .reduce(function (acc, val) {
          return Object.assign(acc, val);
        });
    },
    getSubTotals() {
      return this.getAllColumns(this.columns)
        .map((c) => {
          if (c.subTotal == "SUM") {
            let globalField = { ...getGlobalField(c.screenField) };
            if (globalField) {
              globalField["column"] = globalField.dataField; // this.getColumnName(globalField);
              globalField["value-format"] = this.getDecimalFormatFromHelper(
                c.format ? c.format : globalField["format"],
              );
              globalField["summary-type"] = "sum";
            }
            return globalField;
          }
          if (c.subTotal == "AVG") {
            let globalField = { ...getGlobalField(c.screenField) };
            if (globalField) {
              globalField["column"] = globalField.dataField; // this.getColumnName(globalField);
              globalField["value-format"] = this.getDecimalFormatFromHelper(
                c.format ? c.format : globalField["format"],
              );
              globalField["summary-type"] = "avg";
            }
            return globalField;
          }
          if (c.subTotal == "MAX") {
            let globalField = { ...getGlobalField(c.screenField) };
            if (globalField) {
              globalField["column"] = globalField.dataField;
              if (globalField.type == "Date") {
                globalField["value-format"] = "dd MMM yyyy";
              } else {
                globalField["value-format"] = this.getDecimalFormatFromHelper(
                  c.format ? c.format : globalField["format"],
                );
              }
              globalField["summary-type"] = "max";
            }
            return globalField;
          }
          if (c.subTotal == "COUNT") {
            let globalField = { ...getGlobalField(c.screenField) };
            if (globalField) {
              globalField["column"] = globalField.dataField; // this.getColumnName(globalField);
              globalField["value-format"] = this.getDecimalFormatFromHelper(
                c.format ? c.format : globalField["format"],
              );
              globalField["summary-type"] = "count";
            }
            return globalField;
          }
        })
        .filter((x) => x != null);
    },
    gridColumns() {
      // transform incoming columns to dev express columns
      let gridColumnsArray = this.columns
        .map((c) => {
          let globalField = getGlobalField(c.screenField);

          return { ...globalField, ...c }; // merge global field and the column definition
        })
        .filter((x) => x.dataField != null) // TODO: correct this condition to accommodate all valid columns
        .map((x) => {
          let column = this.parseColumn(x);
          return column;
        });

      // add pad column based on prop value
      if (this.padColumn) {
        gridColumnsArray.push({
          label: "",
          dataField: "",
          width: 5,
          minWidth: 5,
          type: "String",
          columnMinWidth: 5,
          fixed: true,
          fixedPosition: "right",
          allowExporting: false,
          allowGrouping: false,
          allowHiding: false,
          showInColumnChooser: false,
        });
      }

      // gridColumnsArray.push(
      // {
      //   cellTemplate: 'pdf-view-cell-template',
      //   fixed: true,
      //   fixedPosition: "right",
      //   allowExporting: false,
      //   allowGrouping: false,
      //   allowHiding: false,
      //   showInColumnChooser: false,
      // },
      // {
      //   cellTemplate: 'print-cell-template',
      //   fixed: true,
      //   fixedPosition: "right",
      //   allowExporting: false,
      //   allowGrouping: false,
      //   allowHiding: false,
      //   showInColumnChooser: false,
      // },
      // {
      //   cellTemplate: 'menu-cell-template',
      //   fixed: true,
      //   fixedPosition: "right",
      //   allowExporting: false,
      //   allowGrouping: false,
      //   allowHiding: false,
      //   showInColumnChooser: false,
      // },
      // )

      if (
        this.persistenceKey &&
        DataGridState.isAvailable(this.persistenceKey)
      ) {
        var columns = DataGridState.getColumns(
          this.persistenceKey,
          this.appendHiddenColumns(gridColumnsArray),
        );
        return columns;
        // return this.appendHiddenColumns(gridColumnsArray);
      } else return this.appendHiddenColumns(gridColumnsArray);
    },
    gridFilters() {
      // transform incoming columns to dev express form fields
      return [];
    },
    getFilterFormHeight() {
      if (this.getGridHeight) return this.getGridHeight;
      else return undefined;
    },

    getGridDefinitions() {
      const gridDefinitions = this.getGridViewDefinitionByKey(
        this.persistenceKey,
      );

      return gridDefinitions;
    },

    isAdminUser() {
      return secureStorage.get("isAdmin");
    },
  },
  async created() {
    if (this.dataSourceConfig && this.dataSourceConfig.autoExpandAll) {
      this.setAutoExpand = this.dataSourceConfig.autoExpandAll;
      this.groupExpand = true;
    }

    if (this.baseView && this.baseView.query) {
      const autoExpand = this.baseView.query.AutoExpand;
      if (autoExpand === true || autoExpand === "true") {
        this.setAutoExpand = true;
        this.groupExpand = true;
      }
    }

    if (CommonStorage.getItems(this.persistenceKey + "-scroll-offset"))
      this.scrollingOffSet = JSON.parse(
        CommonStorage.getItems(this.persistenceKey + "-scroll-offset"),
      );

    if (this.persistenceKey) {
      DataGridState.setSearchText(this.persistenceKey);
    }

    if (this.defaultUserSettings)
      this.$store.dispatch(
        "defaultUserSettings/setDefaultCompanyBranchDivision",
      );
    if (this.isLocalDataSource && !this.dataSourceConfig.localDataList) {
      let ds = ApiService.createDataSource(
        "api/" + this.dataSourceConfig.endpoint,
        {
          count: true,
          preventPagination:
            this.dataSourceConfig.serverPaging !== undefined
              ? this.dataSourceConfig.serverPaging
              : true,
          expand: this.dataSourceConfig.expand,
          postProcess: this.dataSourceConfig.postProcessCallback
            ? this.dataSourceConfig.postProcessCallback
            : (data) => data,
          select: this.dataSourceConfig.select
            ? this.dataSourceConfig.select
            : undefined,
        },
      );

      if (this.finalFilterValues && this.finalFilterValues.length > 0) {
        ds.filter(this.finalFilterValues);
      }

      ds.load().then(() => {
        this.localDs = ds.items();
      });
    } else if (this.isLocalDataSource && this.dataSourceConfig.localDataList) {
      // this.localDs = this.dataSourceConfig.items;

      if (this.dataSourceConfig.postProcessCallback)
        this.localDs = this.dataSourceConfig.postProcessCallback(
          this.dataSourceConfig.items,
        );
      else this.localDs = this.dataSourceConfig.items;
    }

    // Toolbar PDF Button Options
    if (
      this.gridToolbar.screenName &&
      (this.gridToolbar.pdf == true || this.gridToolbar.multiplePdf)
    ) {
      if (this.reportPdfScreens) {
        var previewPdfs = this.reportPdfScreens.filter(
          (x) =>
            x.ScreenName == this.gridToolbar.screenName &&
            x.AvailableForPDFPreview == "Y",
        );

        if (previewPdfs.length > 0 && this.gridToolbar.pdfPreviewMenuItems) {
          if (this.gridToolbar.pdfPreviewMenuItems.makeDisabled) {
            previewPdfs = this.gridToolbar.pdfPreviewMenuItems.makeDisabled(
              this.dataModel,
              previewPdfs,
            );
          }
        }

        this.previewPdfs = previewPdfs;
      }
    }

    if (this.gridToolbar.screenName && this.gridToolbar.email == true) {
      if (this.reportPdfScreens) {
        var emailRecords = this.reportPdfScreens.filter(
          (x) =>
            x.ScreenName == this.gridToolbar.screenName &&
            x.AvailableForEmail == "Y",
        );

        if (emailRecords.length > 0 && this.gridToolbar.emailMenuItems) {
          if (this.gridToolbar.emailMenuItems.makeDisabled) {
            emailRecords = this.gridToolbar.emailMenuItems.makeDisabled(
              this.dataModel,
              emailRecords,
            );
          }
        }

        this.emailRecords = emailRecords;
      }
    }

    // if (this.gridHeightOverWrite != null) {
    //   this.$store.dispatch("ui/gridHeight", this.gridHeightOverWrite);
    // } else {
    //   this.$store.dispatch("ui/gridHeight", null);
    // }
    this.gridLoaded = true;
  },

  methods: {
    getAllColumns(columns) {
      const setColumns = [];

      columns.forEach((column) => {
        setColumns.push(column);
        if (column.columns && Array.isArray(column.columns)) {
          setColumns.push(...this.getAllColumns(column.columns));
        }
      });

      return setColumns;
    },
    getMasterDetailsRef(lineitem) {
      if (lineitem && lineitem.data && lineitem.data.LineNo)
        return "master-details-" + lineitem.data.LineNo;
      else return "master-details";
    },
    childGridKeyDown(e, data, lineitem) {
      if (data.column.editorOptions && data.column.editorOptions.onKeyDown) {
        let func = data.column.editorOptions.onKeyDown;
        func(e, data, lineitem);
      }
    },
    getChildGridColumns(data) {
      // transform incoming columns to dev express columns

      let columns = [];
      if (typeof this.childGridColumns === "function") {
        columns = this.childGridColumns(data);
      } else {
        columns = this.childGridColumns;
      }

      let gridColumnsArray = columns
        .map((c) => {
          let globalField = getGlobalField(c.screenField);

          return { ...globalField, ...c }; // merge global field and the column definition
        })
        .filter((x) => x.dataField != null) // TODO: correct this condition to accommodate all valid columns
        .map((x) => {
          let column = this.parseColumn(x);

          return column;
        });

      // add pad column based on prop value
      if (this.padColumn) {
        gridColumnsArray.push({
          label: "",
          dataField: "",
          width: 5,
          minWidth: 5,
          type: "String",
          columnMinWidth: 5,
          fixed: true,
          fixedPosition: "right",
          allowExporting: false,
          allowGrouping: false,
          allowHiding: false,
          showInColumnChooser: false,
        });
      }

      return gridColumnsArray;
    },
    addItemToLocalList(data, total) {
      this.totalItemCount = total;
      // data.forEach((element) => {
      //   this.localDs.push(element);
      // });

      this.localDs = this.localDs.concat(data);
    },
    clearLocalList() {
      this.totalItemCount = 0;
      this.localDs = [];
    },
    getLocalItemsList() {
      return this.localDs;
    },
    getChildGridHeaderCheckBoxValue(items) {
      var count = 0;
      items.forEach((element) => {
        if (element.CheckInclude) count++;
      });

      return count == items.length ? true : count == 0 ? false : undefined;
    },
    selectedRowData() {
      return this.$refs[this.gridRef].instance.getSelectedRowsData();
    },
    customLoadState() {
      var state = JSON.parse(CommonStorage.getItems(this.persistenceKey));
      if (state && state.pageSize == 0) state.pageSize = 100;

      return state;
    },
    customSaveState(state) {
      if (state.pageSize == 0) {
        state.pageSize = 100;
      }

      // we do not need to persist the rowKeys
      state.selectedRowKeys = [];

      CommonStorage.saveItems(this.persistenceKey, JSON.stringify(state));

      // this.$nextTick(() => {
      //   DataGridState.saveStateToDatabase(
      //     this.persistenceKey,
      //     JSON.stringify(state),
      //     this.title,
      //   );
      // });
    },
    onKeyDown(e) {
      if (
        this.gridOptions.options.keyboardNavigation != undefined &&
        this.gridOptions.options.keyboardNavigation.onKeyDownCallBack
      )
        this.gridOptions.options.keyboardNavigation.onKeyDownCallBack(e);
    },
    onSelectionChanged(e) {
      if (this.gridOptions && this.gridOptions.options) {
        if (this.gridOptions.options.onSelectionChanged) {
          this.gridOptions.options.onSelectionChanged(e);
        }
        if (this.gridOptions.options.rowSelectCallBack) {
          this.gridOptions.options.rowSelectCallBack(
            this.getSelectedRowsData(),
          );
        }
      } else return false;
    },
    onEditorPrepared(e) {
      if (
        this.gridOptions &&
        this.gridOptions.options &&
        this.gridOptions.options.onEditorPrepared
      ) {
        this.gridOptions.options.onEditorPrepared(e);
      }
    },
    onEditorPreparing(e) {
      if (
        this.gridOptions &&
        this.gridOptions.options &&
        this.gridOptions.options.onEditorPreparing
      ) {
        this.gridOptions.options.onEditorPreparing(e);
      }
      if (e.parentType !== "searchPanel") return;
      let tempFunc = e.editorOptions.onValueChanged;
      e.editorOptions.onValueChanged = (e) => {
        if (e.event && e.value == "") CommonStorage.clear("searchText");
        tempFunc(e);
      };
      e.editorOptions.onKeyDown = (e) => {
        if (e.event) CommonStorage.clear("searchText");
      };
    },
    onBatchEditorPreparing(e) {
      if (e.editorOptions && e.editorOptions.onKeyDown) {
        let func = e.editorOptions.onKeyDown;
        if (this.baseView.mode != "review" && e.parentType != "searchPanel")
          e.editorOptions.onKeyDown = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
              e: e,
            });
          };
      }
    },
    setFilterFinalValue(values) {
      this.filters = values;
    },
    setKeyboardNavigation() {
      if (this.gridOptions && this.gridOptions.options) {
        if (this.gridOptions.options.keyboardNavigation != undefined)
          return this.gridOptions.options.keyboardNavigation;
        else return false;
      } else return false;
    },
    onFocusedCellChanging(e) {
      e.isHighlighted = true;
      if (
        this.gridOptions &&
        this.gridOptions.options &&
        this.gridOptions.options.onFocusedCellChanging
      ) {
        this.gridOptions.options.onFocusedCellChanging(e);
      }
    },
    onFocusedCellChanged(e) {
      e.isHighlighted = true;
      if (
        this.gridOptions &&
        this.gridOptions.options &&
        this.gridOptions.options.onFocusedCellChanged
      ) {
        this.gridOptions.options.onFocusedCellChanged(e);
      }
    },
    setViewLocalItems(value) {
      this.viewLocalItems = value;
    },
    updateHeaderCheckBox(column, value) {
      var checkBox =
        this.$refs["cx-" + column].$refs["select-all-" + column].instance;
      checkBox.option("value", value);
    },
    disableHeaderCheckBox(column, value) {
      var checkBox =
        this.$refs["cx-" + column].$refs["select-all-" + column].instance;
      checkBox.option("readOnly", value);
    },
    updateChildGridHeaderCheckBox() {
      let grid = this.$refs["master-details"].instance;
      var count = 0;
      var gridItems = grid.getDataSource()._store._array;
      gridItems.forEach((element) => {
        if (element.CheckInclude) count = count + 1;
      });

      var checkBox =
        this.$refs["cx-child-grid-CheckInclude"].$refs[
          "select-all-CheckInclude"
        ].instance;

      if (count > 0 && count != gridItems.length) {
        checkBox.option("value", undefined);
      } else if (count == 0) checkBox.option("value", false);
      else if (count == gridItems.length) checkBox.option("value", true);
    },
    parentGridHeaderCheckBox() {
      let grid = this.$refs[this.gridRef].instance;

      var count = 0;
      var gridItems = grid.getDataSource()._store._array;
      gridItems.forEach((element) => {
        if (element.CheckInclude) count = count + 1;
      });

      if (count > 0 && count != gridItems.length) {
        this.updateHeaderCheckBox("CheckInclude", undefined);
      } else if (count == 0) this.updateHeaderCheckBox("CheckInclude", false);
      else if (count == gridItems.length)
        this.updateHeaderCheckBox("CheckInclude", true);
    },
    getGridInstance() {
      return this.$refs[this.gridRef].instance;
    },
    getMasterDataInstance(index) {
      return this.$refs["master-details-" + index].instance;
    },
    calculateCustomSummary(options) {
      if (this.customSummaryFields[options.name]) {
        let field1Key =
          options.name +
          "_" +
          this.customSummaryFields[options.name].valueField1;
        let field2Key =
          options.name +
          "_" +
          this.customSummaryFields[options.name].valueField2;
        // == "AnnualForecastVsBudgetVariancePcnt") {
        switch (options.summaryProcess) {
          case "start":
            // Initializing "totalValue" here
            customAggregateCollection[field1Key] = 0;
            customAggregateCollection[field2Key] = 0;

            options.totalValue = 0;
            break;
          case "calculate":
            customAggregateCollection[field1Key] = (
              customAggregateCollection[field1Key] +
              options.value[this.customSummaryFields[options.name].valueField1]
            ).roundNumber(4);

            customAggregateCollection[field2Key] = (
              customAggregateCollection[field2Key] +
              options.value[this.customSummaryFields[options.name].valueField2]
            ).roundNumber(4);

            break;
          case "finalize":
            // Assigning the final value to "totalValue" here

            if (
              this.customSummaryFields[options.name].aggregatorType ==
              "variancePercent"
            ) {
              options.totalValue =
                customAggregateCollection[field1Key] == 0
                  ? 0
                  : (
                      ((customAggregateCollection[field1Key] -
                        customAggregateCollection[field2Key]) *
                        100) /
                      customAggregateCollection[field1Key]
                    ).roundNumber(4);
            }

            if (
              this.customSummaryFields[options.name].aggregatorType ==
              "variance"
            ) {
              options.totalValue =
                customAggregateCollection[field1Key] == 0
                  ? 0
                  : (
                      customAggregateCollection[field1Key] -
                      customAggregateCollection[field2Key]
                    ).roundNumber(4);
            }

            break;
        }
      }
    },

    formatGroupCellDisplay(data) {
      if (data.column.calculateGroupCellDisplayValue) {
        return data.column.calculateGroupCellDisplayValue(data);
      } else if (
        data.column.caption == "Month" &&
        data.column.dataField == "DateGroupDisplay"
      ) {
        return data.displayValue.split(":")[1];
      } else return data.text;
    },
    gridRefresh(e) {
      var grid = this.$refs[this.gridRef].instance;
      if (e) grid.refresh(true);
      else grid.refresh();
    },
    gridRepaint() {
      var grid = this.$refs[this.gridRef].instance;
      // console.log(this.gridRef);
      grid.refresh(true);
    },
    gridRepaint2() {
      var grid = this.$refs[this.gridRef].instance;
      grid.repaint();
    },
    refreshColumns() {
      var grid = this.$refs[this.gridRef].instance;
      grid.option("columns", this.gridColumns);
    },
    setDataSource(dataSource) {
      var grid = this.$refs[this.gridRef].instance;
      grid.option("dataSource", dataSource);
    },
    getSelectedRowsData() {
      var grid = this.$refs[this.gridRef].instance;
      return grid.getSelectedRowsData();
    },
    showLoading(show) {
      this.loadingVisible = show;
    },
    validationSummary(itemArray) {
      this.validationItems = [];
      if (itemArray)
        itemArray.forEach((x) => {
          this.validationItems.push(x.message);
        });
      this.validationSummaryVisible = true;
    },
    valueChangeCallBack(e, lineData, parentRowData) {
      let eventListner = this.valueChangeListners.find(
        (listner) => listner.dataField == lineData.column.dataField,
      );

      if (eventListner) {
        eventListner.listner(e, lineData, parentRowData);
        this.itemsMutationIndex++;
      } else {
        // eslint-disable-next-line no-console
        console.log("Listner Not Found : ", lineData.column.dataField);

        if (lineData.column.valueChangeCallBack) {
          let grid = this.$refs[this.gridRef].instance;
          lineData.column.valueChangeCallBack(e, lineData, grid);
        }
      }
    },
    fieldItemOptions(data) {
      return data.column.editorData;
    },
    detailQtyChanged(e, lineData) {
      let eventListnerdataField = lineData.column.dataField;
      let eventListner = this.valueChangeListners.find(
        (listner) => listner.dataField == eventListnerdataField,
      );

      let grid = this.$refs[this.gridRef].instance;

      if (eventListner) {
        eventListner.listner(e, lineData, grid);
        this.itemsMutationIndex++;
      } else {
        if (lineData.column.valueChangeCallBack) {
          // eslint-disable-next-line no-console
          console.log("CX Log >>> valueChangeCallBack Found : ");

          lineData.column.valueChangeCallBack(e, lineData, grid);
        } else {
          // eslint-disable-next-line no-console
          console.log("Listner Not Found : ", lineData.column.dataField);
        }
      }
    },
    childGridValueChanged(e, lineData, lineParent) {
      let eventListnerdataField = lineData.column.dataField;
      let eventListner = this.valueChangeListners.find(
        (listner) => listner.dataField == eventListnerdataField,
      );
      // let grid = this.$refs[this.gridRef].instance;

      if (eventListner) {
        eventListner.listner(e, lineData, lineParent);
        this.itemsMutationIndex++;
      } else {
        // eslint-disable-next-line no-console
        console.log("Listner Not Found : ", lineData.column.dataField);
      }
    },
    batchQtyChanged(e, lineData, lineParent) {
      let batchGrid = lineData.component.instance();
      let eventListnerdataField = lineData.column.dataField;
      let eventListner = this.valueChangeListners.find(
        (listner) => listner.dataField == eventListnerdataField,
      );
      let grid = this.$refs[this.gridRef].instance;

      let refKey = lineParent.data.LineNo
        ? "cx-child-grid-" + lineParent.data.LineNo
        : "cx-child-grid-" + lineData.column.dataField;

      var refInstance = this.$refs[refKey]
        ? this.$refs[refKey].getSeletcAllRef().instance
        : undefined;

      if (eventListner) {
        eventListner.listner(
          e,
          lineData,
          grid.getDataSource().items(),
          grid,
          lineParent,
          batchGrid,
          refInstance,
        );
        this.itemsMutationIndex++;
      } else {
        // eslint-disable-next-line no-console
        console.log("Listner Not Found : ", lineData.column.dataField);
      }
    },
    getDataSource() {
      let grid = this.$refs[this.gridRef].instance;
      return grid.getDataSource().items();
    },
    getDataSourceInstance() {
      return this.$refs[this.gridRef].instance;
    },
    updateOptions(option, value) {
      let grid = this.$refs[this.gridRef].instance;
      grid.beginUpdate();
      grid.option(option, value);
      grid.endUpdate();
    },
    checkBoxValueChange(fieldData, recordData) {
      fieldData.component.instance().blur();
      let eventListner = this.valueChangeListners.find(
        (listner) => listner.dataField == recordData.column.dataField,
      );

      if (eventListner && fieldData.event) {
        let grid = this.$refs[this.gridRef].instance;
        if (eventListner) {
          eventListner.listner(
            fieldData,
            recordData,
            grid,
            this.updateIsDefault,
          );
        } else {
          // eslint-disable-next-line no-console
          console.log("Listner Not Found : ", recordData.column.dataField);
        }
      } else if (recordData.column.valueChangeCallBack) {
        var refInstance = this.$refs["cx-" + recordData.column.dataField]
          ? this.$refs["cx-" + recordData.column.dataField].getSeletcAllRef()
              .instance
          : undefined;

        // var childRefInstance = this.$refs[
        //   "cx-child-grid-" + recordData.column.dataField
        // ]
        //   ? this.$refs[
        //       "cx-child-grid-" + recordData.column.dataField
        //     ].getSeletcAllRef().instance
        //   : undefined;
        recordData.column.valueChangeCallBack(
          fieldData,
          recordData,
          refInstance,
          this.$refs[this.gridRef].instance,
          // childRefInstance
        );
        // this.itemsMutationIndex++;
      }
    },
    childGridCheckBoxValueChange(fieldData, recordData) {
      if (!fieldData.event) return;
      let eventListner = this.valueChangeListners.find(
        (listner) => listner.dataField == recordData.column.dataField,
      );

      if (eventListner && fieldData.event) {
        let grid = this.$refs["master-details"].instance;
        if (eventListner) {
          eventListner.listner(
            fieldData,
            recordData,
            grid,
            this.updateIsDefault,
          );
        } else {
          // eslint-disable-next-line no-console
          console.log("Listner Not Found : ", recordData.column.dataField);
        }
      } else if (recordData.column.valueChangeCallBack) {
        let refName = "cx-child-grid-" + recordData.column.dataField;

        if (recordData.data && recordData.data.ParentLineNo != undefined) {
          refName = "cx-child-grid-" + recordData.data.ParentLineNo;
        }

        var refInstance = this.$refs[refName]
          ? this.$refs[refName].getSeletcAllRef().instance
          : undefined;
        recordData.column.valueChangeCallBack(
          fieldData,
          recordData,
          refInstance,
          this.$refs[this.gridRef].instance,
        );
        // this.itemsMutationIndex++;
      }
    },
    async radioValueChange(cellInfo, event) {
      let eventListner = this.valueChangeListners.find(
        (listner) => listner.dataField == cellInfo.column.dataField,
      );
      if (event.value) {
        if (eventListner) {
          let grid = this.$refs[this.gridRef].instance;
          if (eventListner) {
            eventListner.listner(event, cellInfo, grid, this.updateIsDefault);
          } else {
            // eslint-disable-next-line no-console
            console.log("Listner Not Found : ", cellInfo.column.dataField);
          }
        } else {
          let grid = this.$refs[this.gridRef].instance;
          var items = grid.getDataSource().items();
          var getDefault,
            clickedDefault = undefined;
          if (items)
            items.forEach((element) => {
              if (element.Code == cellInfo.data.Code)
                clickedDefault = element.Description;
              if (element.IsDefault == "Y") getDefault = element.Description;
            });
          let confirmLeaving = await this.$confirm(
            `Do you want to change the default setting from ${getDefault} to ${clickedDefault} ?`,
            "Default Setting Change",
          );

          if (!confirmLeaving) {
            event.component.beginUpdate();
            event.component.option("value", false);
            event.component.endUpdate();
            return;
          }
          if (this.updateIsDefault) {
            this.$store.dispatch("ui/setUpdateIsDefault", {
              update: true,
              code: cellInfo.data.Code,
              event: event,
            });
          }
        }
      }
    },
    formPopupBackButtonClick() {
      this.formPopupVisible = false;
      this.auditPopupVisible = false;
    },
    expandGrid() {
      // if (!this.gridExpand) this.$store.dispatch("ui/headerFormHeight", 6);
      this.$store.dispatch("ui/setGridExpand", !this.gridExpand);

      setTimeout(() => {
        this.$store.dispatch("ui/checkGridNoData", true);
        this.reSizeGrid();
      }, 500);
    },
    onItemClickCallBack(data, e) {
      if (e.itemData.clickAction == "lineComment") {
        this.formPopupTitle = "Line Comment";
        this.formPopupItems = data.column.ellipsisMenu.formItems;
        this.formPopupDataModel = data.data;

        this.formPopupVisible = true;
      } else if (e.itemData.clickAction) {
        let grid = this.$refs[this.gridRef].instance;
        e.itemData.clickAction(data.data, grid);
      }
    },
    onHyperlinkClicked(data) {
      let hyperLinkCallBack = data.column.hyperLinkCallBack;

      if (hyperLinkCallBack) hyperLinkCallBack(data);
      else
        setTimeout(() => {
          let baseUrl = process.env.VUE_APP_BASE_URL;
          let url = "";
          if (data.column.hyperlink.gridUrlConditions) {
            data.column.hyperlink.url = "";
            // let obj = data.column.hyperlink.gridUrlConditions.find(
            //   (el) => {
            //     if(el.key2) {
            //       if(el.key == data.data[data.column.hyperlink.gridUrlDataField] && el.key2 == data.data[data.column.hyperlink.gridUrlDataField2])
            //         return el;
            //     }else {
            //       return el.key == data.data[data.column.hyperlink.gridUrlDataField]
            //     }
            //   }
            // );

            // data.column.hyperlink.url = obj.value;

            var count = 0;
            var gridUrlDataFields = data.column.hyperlink.gridUrlDataFields;
            var gridUrlConditions = data.column.hyperlink.gridUrlConditions;

            for (let index = 0; index < gridUrlConditions.length; index++) {
              const values = gridUrlConditions[index].values;
              count = 0;

              for (let x = 0; x < gridUrlDataFields.length; x++) {
                const dataField = gridUrlDataFields[x];

                for (let c = 0; c < values.length; c++) {
                  const element = values[c];
                  for (const key in element)
                    if (key == dataField)
                      if (element[dataField] == data.data[dataField]) {
                        count++;
                      } else count = 0;
                }
              }

              if (count == values.length)
                data.column.hyperlink.url = gridUrlConditions[index].url;
            }
          }

          var dataField = data.column.dataField;
          if (data.column.hyperlink.dataField)
            dataField = data.column.hyperlink.dataField;

          if (baseUrl === "/")
            url = `${baseUrl}${data.column.hyperlink.url.replace(
              "__ID__",
              data.data[dataField],
            )}`;
          else
            url = `/${data.column.hyperlink.url.replace(
              "__ID__",
              data.data[dataField],
            )}`;

          // eslint-disable-next-line no-console
          // console.log("url ", url);

          if (data.column.hyperlink.url) {
            var query = {};
            if (data.column.hyperlink.params) {
              data.column.hyperlink.params.forEach((element) => {
                let globalField = { ...getGlobalField(element) };

                var index = this.gridColumns.findIndex(
                  (x) => x.screenField == globalField.fieldName,
                );

                var valueField = undefined;
                if (index != -1) {
                  if (this.gridColumns[index].hyperLinkDataField) {
                    valueField = this.gridColumns[index].hyperLinkDataField;
                  } else if (this.gridColumns[index].filterDataField) {
                    valueField = this.gridColumns[index].filterDataField;
                  } else {
                    valueField = globalField.dataField;
                  }
                } else {
                  valueField = globalField.dataField;
                }

                if (data.data[valueField]) {
                  var value = data.data[valueField];

                  if (typeof value == "string") {
                    value = value.replace(" ", "");
                    value = value.split(",");
                  }

                  if (
                    globalField.type == "String" &&
                    globalField.cellTemplate == "Record"
                  )
                    if (Array.isArray(value))
                      query[element] = JSON.stringify(value);
                    else query[element] = JSON.stringify([value]);
                  else query[element] = JSON.stringify(value);
                }
              });
            }

            if (data.column.hyperlink.fixedParams) {
              for (
                let c = 0;
                c < data.column.hyperlink.fixedParams.length;
                c++
              ) {
                const param = data.column.hyperlink.fixedParams[c];
                for (const key in param) {
                  //
                  let globalField = { ...getGlobalField(key) };
                  if (
                    globalField.type == "String" &&
                    globalField.cellTemplate == "Record"
                  ) {
                    if (Array.isArray(param[key]))
                      query[key] = JSON.stringify(param[key]);
                    else query[key] = JSON.stringify([param[key]]);
                  } else {
                    if (Array.isArray(param[key]))
                      query[key] = JSON.stringify(param[key]);
                    else query[key] = param[key];
                  }
                }
              }
            }

            var route = this.$router.resolve({ path: url, query: query });
            window.open(route.href, data.column.hyperlink.target);
          }
        }, 25);
    },
    setGridPanelFilter(filters, valueChanged) {
      this.gridPanelFilter = filters && filters.length > 0 ? [...filters] : [];
      var grid = this.$refs[this.gridRef].instance;

      if (
        filters.length == 0 &&
        valueChanged &&
        this.persistenceKey &&
        CommonStorage.getItems("remove_state")
      ) {
        // CommonStorage.saveItems("remove_state", false);
        CommonStorage.saveItems("remove_state_2", new Date().getTime());
        grid.state(null);
        grid.refresh(true);
        grid.repaint();
      } else {
        if (
          (filters.length == 0 || filters.length > 0) &&
          valueChanged &&
          this.persistenceKey &&
          this.id == "grid-report-grid"
        ) {
          // grid.state(null);
          grid.refresh(true);
          grid.repaint();
          // return;
        }
      }

      if (
        this.persistenceKey
        // && valueChanged
        // &&
        // this.gridPanelFilter.length > 0
      )
        CommonStorage.saveItems(
          "filter-panel-" + this.persistenceKey,
          JSON.stringify(this.gridPanelFilter), // , replacer
        );

      this.proceedDataLoading = true;
      var combinedFilters = grid.getCombinedFilter();
      if (
        (this.isLocalDataSource || this.dataSourceConfig.remote) &&
        (filters.length != 0 ||
          (this.dataSourceConfig.remote && this.finalFilterValues.length != 0))
      ) {
        if (this.initiateDataLoading == false) {
          grid.option("dataSource", this.originalDataSourceConfig);
        }
        if (this.dataSourceConfig.remote) {
          if (
            !this.dataSourceConfig.filter ||
            this.dataSourceConfig.filter.length == 0
          ) {
            grid.filter(this.finalFilterValues);
          } else {
            grid.option("dataSource", this.gridRemoteDataSource);
          }
        } else {
          grid.filter(this.finalFilterValues);
        }
      } else {
        if (!combinedFilters || valueChanged) {
          if (
            this.viewLocalItems &&
            this.finalFilterValues &&
            this.finalFilterValues.length > 0
          ) {
            grid.filter(this.finalFilterValues);
          } else {
            grid.clearFilter();
          }
        }
        this.initiateDataLoading = true;
      }

      this.$nextTick(() => {
        // if (CommonStorage.getItems("filter-panel-" + this.persistenceKey)) {
        //   DataGridState.saveStateAndFilterToDatabase(
        //     this.persistenceKey,
        //     this.title,
        //   );
        // }
        if (
          this.gridOptions &&
          this.gridOptions.options &&
          this.gridOptions.options.onFilterCallBack
        ) {
          this.gridOptions.options.onFilterCallBack();
        }
      });
    },
    onOptionChanged(e) {
      if (e.fullName == "searchPanel.text") {
        if (e.value != "") {
          this.currentSearchText = e.value;
          this.$store.dispatch("dataContext/setSearchText", e.value);
          Vue.prototype.$logger.trackEventGridSearch({
            value: e.value,
          });
        } else {
          this.currentSearchText = undefined;
          this.$store.dispatch("dataContext/setSearchText", undefined);
        }
      }

      var scrollComponent = e.component.getScrollable();

      if (scrollComponent) {
        CommonStorage.saveItems(
          this.persistenceKey + "-scroll-offset",
          JSON.stringify(scrollComponent.scrollOffset()),
        );
      }

      // if (e.fullName == "dataSource") {
      //   console.log("////////////////////////////////////");
      //   if (CommonStorage.getItems("searchText")) {
      //     e.component.searchByText(CommonStorage.getItems("searchText"));
      //     CommonStorage.clear("searchText");
      //   }
      // }
    },
    onBatchEditStarting(e) {
      if (
        this.gridOptions &&
        this.gridOptions.options &&
        this.gridOptions.options.onBatchEditStarting
      ) {
        this.gridOptions.options.onBatchEditStarting(e);
      }
    },
    onCellPrepared(e, subTotals) {
      if (
        this.gridOptions &&
        this.gridOptions.options &&
        this.gridOptions.options.onCellPreparedCallBack
      ) {
        this.gridOptions.options.onCellPreparedCallBack(e);
      }

      if (e.rowType === "data" && e.column.dataField == "CheckInclude") {
        if (e.column.editorOptions) {
          if (e.column.editorOptions.onKeyDown) {
            var tempKeyDown = e.column.editorOptions.onKeyDown;
            e.column.editorOptions.onKeyDown = (event) => {
              tempKeyDown(event, { rowIndex: e.rowIndex, data: e.data });
            };
          }
        }
      }

      if (e.rowType === "data" && e.column.command === "expand") {
        // console.log('CX Logger',e.data.ItemCode , " - ",e.data.IsBatchProduct , " - ", e.data.IsVisibleBatchData);
        var removeBatchExpand = false;
        if (
          e.data.IsBatchProduct == "Auto" &&
          e.data.IsVisibleBatchData != undefined
        ) {
          if (e.data.IsVisibleBatchData == true) removeBatchExpand = false;
        }
        // else {
        // Auto batch products now has the ability to specify Supplier's Batch and Expiry: ADO User Story #32687
        // if (e.data.IsBatchProduct == "Auto") removeBatchExpand = true;
        // }

        if (e.data.IsBatchProduct == "No" || removeBatchExpand) {
          if (e.cellElement && e.cellElement.classList) {
            e.cellElement.classList.remove("dx-datagrid-expand");
            e.cellElement.childNodes[0].classList.remove(
              "dx-datagrid-group-closed",
            );
          }
        }
      }
      if (!e.summaryItems) return;
      if (e.rowType == "group" && subTotals) {
        subTotals.forEach((element) => {
          let si = e.summaryItems.find(
            (i) => i.showInColumn == element["dataField"],
          );
          if (si) {
            let cell = e.cellElement.querySelector(".dx-datagrid-summary-item");
            if (si.value == 0) {
              if (cell) cell.innerHTML = "-";
            } else if (si.value < 0 && cell) cell.classList.add("avail-error");
          }
        });
      }
    },
    onRowPrepared(e) {
      if (
        this.gridOptions &&
        this.gridOptions.options &&
        this.gridOptions.options.onRowPreparedCallBack
      ) {
        this.gridOptions.options.onRowPreparedCallBack(e);
      }

      // if(e.rowType == "group") {
      //     var visibleColumns = e.columns.filter((x) => x.visible && x.dataField);
      //     if(visibleColumns.length > 0){

      //       visibleColumns.forEach((element, index) => {
      //         if(element.rowColorNegative){
      //             // if(e.data.summary[index] < 0){
      //             //   console.log('onRowPrepared ', index , e.data.summary[index], e);
      //             // }
      //         }
      //       });
      //     }
      // }

      if (e.rowType == "data") {
        e.columns.forEach((element) => {
          if (element.rowColorNegative) {
            if (e.data[element.dataField] < 0) {
              e.rowElement.classList.add("rowColorNegative");
              e.rowElement.classList.remove("dx-row-alt");
            }
          }
        });
      }

      if (e.rowType == "totalFooter") {
        e.cells.forEach((element) => {
          element.totalItem.cells.forEach((cell) => {
            if (cell.summaryItems && cell.summaryItems.length != 0) {
              if (cell.summaryItems[0].value < 0)
                cell.cellElement.childNodes[0].classList.add("avail-error");
            }
          });
        });
      }

      // if (e.rowType == "data" && this.gridToolbar.expandMasterDetails) {
      //   let instance = e.component;
      //   setTimeout(() => {
      //     if (e.data.ChildDataSource.length > 0) instance.expandRow(e.key);
      //   }, 100);
      // }
    },
    getColumnName(item) {
      return this.gridColumns.filter((x) => {
        return x.dataField == item["dataField"];
      })[0].caption;
    },
    getDecimalFormatFromHelper(format) {
      if (format) return getDecimalFormat(format).ReadOnlyFormat;
    },
    onContentReady(e) {
      this.dataGridView = this.dataViewType;
      this.addGridNoResults(e);

      // this.filterFormHeight =
      //   document.getElementsByClassName("dx-datagrid dx-gridbase-container")[0]
      //     .clientHeight -
      //   document.getElementsByClassName("dx-datagrid-header-panel")[0]
      //     .clientHeight -
      //   30;

      if (e.component.getVisibleRows().length < this.totalItemCount) {
        this.checkTotalItemCount();
      } else {
        clearInterval(this.countIntervalID);
        this.loadingVisible = false;
      }

      if (e.component.getDataSource()) {
        this.gridDataSourceItems = e.component.getDataSource()._items;
        if (CommonStorage.getItems("searchText")) {
          e.component.searchByText(CommonStorage.getItems("searchText"));
          // CommonStorage.clear("searchText");
        }

        var searchBox = e.element.querySelector(
          ".dx-datagrid-search-panel .dx-texteditor-input",
        );
        if (searchBox)
          if (this.gridDataSourceItems.length == 0 && !this.currentSearchText)
            searchBox.disabled = true;
          else searchBox.disabled = false;

        // console.log('XXX ', this.gridDataSourceItems, this.scrollingOffSet);

        if (this.gridDataSourceItems.length > 0 && this.scrollingOffSet) {
          var scrollComponent = e.component.getScrollable();
          scrollComponent.scrollBy(this.scrollingOffSet);
          CommonStorage.saveItems(
            this.persistenceKey + "-scroll-offset",
            JSON.stringify(this.scrollingOffSet),
          );
          this.scrollingOffSet = undefined;
        }

        if (
          this.gridOptions &&
          this.gridOptions.options &&
          this.gridOptions.options.onContentReadyCallBack
        ) {
          this.gridOptions.options.onContentReadyCallBack(e);
        }

        if (this.getSelectedRowKeys.length > 0)
          this.selectRows(this.getSelectedRowKeys);
      } else {
        this.gridDataSourceItems = [];
      }

      if (this.gridOptions && this.gridOptions.dataGridViews) {
        this.gridDataSourceItems = this.reviewDataSource;
      }

      this.itemsMutationIndex++;

      // remove tabindex from grid header row
      var headers = e.element.querySelector(".dx-datagrid-headers");
      headers.querySelectorAll("[tabindex]").forEach(function (header) {
        header.removeAttribute("tabIndex");
      });

      setTimeout(() => {
        this.reSizeGrid();
      }, 100);
    },
    checkTotalItemCount() {
      if (this.$refs[this.gridRef]) {
        let grid = this.$refs[this.gridRef].instance;
        let visibleRows = grid.getVisibleRows().length;

        // Introduce a tolerance, for example, 1
        const tolerance = 1;

        if (Math.abs(visibleRows - this.totalItemCount) <= tolerance) {
          if (this.countIntervalID) {
            clearInterval(this.countIntervalID);
          }
          this.loadingVisible = false;
        } else {
          this.countIntervalID = setInterval(
            this.checkTotalItemCount.bind(this),
            5000,
          );
        }
      } else {
        if (this.countIntervalID) {
          clearInterval(this.countIntervalID);
        }
      }
    },

    saveAsNewGridLayout() {
      this.$store.dispatch("ui/setVisibleGridSavePopup", true);
    },
    async saveGridLayoutToDB(templateType) {
      let selectedValue,
        selectedValueData = null;

      const dropdownInstance =
        this.$refs[`GcReorderableDropdown-${this.persistenceKey}`];

      if (!dropdownInstance) return;

      selectedValue = dropdownInstance.getSelectedValue();

      if (selectedValue) {
        CommonStorage.saveItems(
          this.persistenceKey + "-RecordID",
          selectedValue,
        );
      }

      selectedValueData = dropdownInstance.getSelectedValueData();

      const existingDefinition = this.getDefinitionWithSameKeyAndName(
        this.persistenceKey,
        selectedValueData.TemplateName,
        templateType,
        selectedValue,
      );

      const TemplateName = existingDefinition
        ? existingDefinition.TemplateName
        : selectedValueData
        ? selectedValueData.TemplateName
        : this.title;

      let shouldSave = true;

      if (
        templateType === "Me" &&
        (existingDefinition ||
          selectedValueData.TemplateType.toLowerCase() === "me")
      ) {
        shouldSave = await this.$confirm(
          "Are you sure you want to overwrite your current layout with the new changes?",
          "Confirm Save",
        );
      }

      if (!shouldSave) return;

      this.showLoading(true);

      try {
        let recordId = null;

        if (existingDefinition) {
          recordId = existingDefinition.RecordID;
        } else if (
          selectedValueData &&
          selectedValueData.TemplateType.toLowerCase() ===
            templateType.toLowerCase()
        ) {
          recordId = selectedValueData.RecordID;
        }

        const response = await DataGridState.saveStateAndFilterToDatabase(
          this.persistenceKey,
          TemplateName,
          templateType,
          existingDefinition ? "Save" : "New",
          this.originalColumns,
          recordId,
        );

        if (response) {
          this.$notify("Grid layout saved successfully!", "success");

          this.$nextTick(() => {
            this.$emit("update:visible", false);
          });
        }
      } catch (error) {
        this.$store.dispatch("ui/setServerError", {
          error: error,
          title: "Failed",
        });
      } finally {
        this.showLoading(false);
      }
    },
    saveMyGridLayout() {
      this.saveGridLayoutToDB("Me");
    },
    showViewDefinitionReorderPopup(e) {
      if (!e || !e.event) return;

      this.visibleReorderSavePopup = true;
    },

    saveForEveryoneGridLayout() {
      this.saveGridLayoutToDB("Everyone");
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });

      var exportButton = toolbarItems.find((item) => {
        return item.name === "exportButton";
      });

      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "exportButton" &&
          item.name !== "searchPanel" &&
          item.name !== "columnChooserButton"
        );
      });
      searchPanel.location = "after";
      exportButton.location = "after";

      if (this.gridToolbar.search && this.gridToolbar.search == true) {
        e.toolbarOptions.items.push(searchPanel);
      }

      if (this.gridToolbar.status) {
        // toolbar-pdf-preview
        e.toolbarOptions.items.push({
          template: "status-chip",
          location: "after",
          locateinmenu: "auto",
        });
      }

      if (this.saveGridLayout && this.persistenceKey) {
        e.toolbarOptions.items.push({
          location: "after",
          locateInMenu: "never", // keep out of overflow menu so our DOM mount works reliably
          template: "reorderableDropdownTemplate", // use a named template slot
        });

        // Save Grid Layout Button with Dropdown
        e.toolbarOptions.items.push({
          location: "after",
          locateinmenu: "auto",
          widget: "dxDropDownButton",
          options: {
            tabIndex: -1,
            icon: "floppy",
            showArrowIcon: false,
            dropDownOptions: {
              width: 150,
            },
            items: [
              {
                text: "Save for me",
                onClick: this.saveMyGridLayout,
              },
              {
                text: "Save for everyone",
                onClick: this.saveForEveryoneGridLayout,
                visible: this.isAdminUser,
              },
              {
                text: "Save as new",
                onClick: this.saveAsNewGridLayout,
              },
            ],
          },
        });

        e.toolbarOptions.items.push({
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            tabIndex: -1,
            icon: "fas fa-sliders-h",
            onClick: this.showViewDefinitionReorderPopup,
          },
        });
      }

      if (
        this.id == "grid-report-grid" &&
        this.dataSourceConfig &&
        this.dataSourceConfig.autoExpandAll != undefined
      ) {
        if (
          this.dataSourceConfig &&
          this.dataSourceConfig.allowGrouping != false
        ) {
          e.toolbarOptions.items.push({
            location: "after",
            locateinmenu: "auto",
            widget: "dxButton",
            ref: "expand-all",
            options: {
              elementAttr: { id: "expand-down" },
              tabIndex: -1,
              icon: !this.groupExpand
                ? "fa-solid fa-angles-down"
                : "fa-solid fa-angles-up",
              onClick: this.onGroupExpand,
            },
          });
        }
      }

      if (this.gridToolbar.export && this.gridToolbar.export == true) {
        exportButton.options.showArrowIcon = false;
        e.toolbarOptions.items.push(exportButton);
      }

      if (
        this.gridToolbar.columnChooser &&
        this.gridToolbar.columnChooser == true
      ) {
        e.toolbarOptions.items.push(columnChooserButton);
      }

      if (this.gridToolbar.expand && this.gridToolbar.expand == true) {
        e.toolbarOptions.items.push({
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          // visible: !this.isTablet,
          options: {
            tabIndex: -1,
            icon: this.gridExpand ? "collapse" : "expand",
            onClick: this.expandGrid,
          },
        });
      }

      if (
        this.gridToolbar.review &&
        this.gridToolbar.review == true &&
        this.gridOptions.dataGridViews
      ) {
        var defaultValue = this.gridOptions.dataGridViews.filter((x) => {
          if (x.default) return x.value;
        });

        e.toolbarOptions.items.push({
          location: "before",
          widget: "dxSelectBox",
          disabled: this.baseView.mode != "review" ? false : true,
          options: {
            width: this.isTablet ? 130 : 200,
            items: this.gridOptions.dataGridViews,
            displayExpr: "label",
            valueExpr: "value",
            value: this.dataViewType
              ? this.dataViewType
              : defaultValue[0].value,
            onValueChanged: this.detailsViewChanged.bind(this),
            onInitialized: function (e) {
              dataGridViewsSelectBox = e.component;
            },
            onOpened: () => {
              var dataGrid = this.$refs[this.gridRef].instance;

              dataGrid.clearSelection();
              dataGrid.option("focusedRowIndex", -1);
            },
          },
        });
      }

      if (
        this.gridToolbar.addNew &&
        this.gridToolbar.addNew == true &&
        this.gridOptions.dataGridViews
      ) {
        // let defaultValue = this.gridOptions.dataGridViews.filter((x) => {
        //   if (x.default) return x.value;
        // });

        e.toolbarOptions.items.push({
          location: "before",
          widget: "dxButton",
          // disabled: this.baseView.mode != "review" ? false : true,
          options: {
            tabIndex: -1,
            validationGroup: "formsData",
            icon: "plus",
            elementAttr: { id: "filter-btn" },
            onClick: () => {
              this.gridToolbar.addNewCallBack();
              // this.showRightContainer = !this.showRightContainer;
              // var item = document.getElementById("filter-btn");
              // this.$logger.debug("item ", item);
              // item.classList.add("dx-state-invisible");
            },
          },
        });
      }

      if (this.gridToolbar.customButtons)
        this.gridToolbar.customButtons.forEach((element) => {
          e.toolbarOptions.items.push({
            location: element.buttonLocation == "left" ? "before" : "after",
            widget: element.widget ? element.widget : "dxButton",
            options: element.options
              ? element.options
              : {
                  icon: element.icon ? element.icon : undefined,
                  text: element.label,
                  elementAttr: element.elementAttr ? element.elementAttr : {},
                  onClick: () => {
                    if (element.routeAction)
                      this.$router.push({
                        path: element.routeAction(),
                        query: element.routeQuery
                          ? element.routeQuery
                          : undefined,
                      });
                    else if (
                      element.clickAction &&
                      typeof element.clickAction == "function"
                    )
                      element.clickAction();
                    else
                      this.$router.push({
                        path: element.route,
                        query: element.routeQuery
                          ? element.routeQuery
                          : undefined,
                      });
                  },
                  onContentReady: (e) => {
                    if (element.onContentReady) element.onContentReady(e);
                  },
                  visible: element.visible == false ? false : true,
                  disabled:
                    element.disabled != null || element.disabled != undefined
                      ? element.disabled
                      : false,
                },
          });
        });

      if (this.gridToolbar.header && this.gridToolbar.header == true) {
        e.toolbarOptions.items.unshift({
          location: "before",
          template: "header-in-toolbar",
        });
      }

      if (this.gridToolbar.form) {
        e.toolbarOptions.items.unshift({
          widget: "dxForm",
          location: "before",
          options: {
            formData: this.dataModel,
            items: this.gridToolbar.form.items,
            validationGroup: "DataGridToolBarForm",
            labelLocation: "left",
            showRequiredMark: false,
            colCount: 2,
            onContentReady: (e) => {
              if (this.gridToolbar.form.formContentReady) {
                this.gridToolbar.form.formContentReady(e);
              }
            },
          },
          locateinmenu: "auto",
        });
      }

      if (
        this.gridToolbar.formSwitch &&
        this.gridToolbar.formSwitch.location == "right"
      ) {
        e.toolbarOptions.items.push({
          widget: "dxForm",
          location: "after",
          options: {
            formData: this.dataModel,
            items: this.gridToolbar.formSwitch.items,
            validationGroup: "formSwitch",
            labelLocation: "left",
            showRequiredMark: false,
          },
          locateinmenu: "auto",
        });
      }

      if (this.gridToolbar.note) {
        e.toolbarOptions.items.push({
          location: "after",
          widget: "dxButton",
          options: {
            icon: "file",

            onClick: () => {
              // this.commentsPopupVisible = true;
              this.$logger.trackEventOpenPopup("Goods Return Comments");

              this.$store.dispatch("ui/setTransactionCommentPopUp", true);
            },
          },
          locateInMenu: "auto",
        });
      }

      if (this.gridToolbar.pdf && this.gridToolbar.screenName) {
        // toolbar-pdf-preview
        e.toolbarOptions.items.push({
          template: "toolbar-pdf-preview",
          location: "after",
          locateinmenu: "auto",
        });
      }

      if (this.gridToolbar.multiplePdf && this.gridToolbar.screenName) {
        // toolbar-pdf-preview
        e.toolbarOptions.items.push({
          template: "toolbar-multiple-pdf-preview",
          location: "after",
          locateinmenu: "auto",
        });
      }

      if (
        this.gridToolbar.email &&
        this.gridToolbar.screenName &&
        this.emailRecords.length > 0
      ) {
        // toolbar-email-preview
        e.toolbarOptions.items.push({
          template: "toolbar-email-preview",
          location: "after",
          locateinmenu: "auto",
        });
      }

      if (this.gridToolbar.audit) {
        e.toolbarOptions.items.push({
          widget: "dxButton",
          location: "after",
          locateinmenu: "auto",
          options: {
            icon: "clock",
            // validationGroup: "DataGridToolBarForm",
            onClick: () => {
              this.auditPopupVisible = true;
            },
          },
        });
      }

      if (this.gridToolbar.save && !this.gridToolbar.saveMenu) {
        e.toolbarOptions.items.push({
          widget: "dxButton",
          location: "after",
          locateinmenu: "auto",
          options: {
            icon: "floppy",
            validationGroup: this.gridToolbar.form
              ? "DataGridToolBarForm"
              : undefined,
            onClick: (e) => {
              this.saveCallBack(
                e.validationGroup.validate().isValid,
                e.validationGroup.validate().brokenRules,
              );
            },
          },
        });
      }

      if (this.gridToolbar.save && this.gridToolbar.saveMenu) {
        e.toolbarOptions.items.push({
          widget: "dxDropDownButton",
          location: "after",
          locateinmenu: "auto",
          options: {
            items: this.gridToolbar.saveMenu.items,
            keyExpr: this.gridToolbar.saveMenu.keyExpr,
            displayExpr: this.gridToolbar.saveMenu.displayExpr,
            showArrowIcon: false,
            dropDownOptions: this.gridToolbar.saveMenu.dropDownOptions,
            stylingMode: "text",
            icon: this.gridToolbar.saveMenu.icon,
            onItemClick: (e) => {
              this.saveCallBack(true, [], e.itemData);
            },
          },
        });
      }

      if (this.gridToolbar.openFilter && this.gridToolbar.openFilter == true) {
        e.toolbarOptions.items.push({
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            icon: "filter",
            elementAttr: { id: "filter-btn" },
            onClick: () => {
              this.showRightContainer = !this.showRightContainer;
              var item = document.getElementById("filter-btn");
              this.$logger.debug("item ", item);
              item.classList.add("dx-state-invisible");

              setTimeout(() => {
                this.reSizeGrid();
              }, 50);
            },
            visible: !this.showRightContainer,
          },
        });
      }

      if (this.gridToolbar.ellipsis) {
        e.toolbarOptions.items.push({
          location: "after",
          locateinmenu: "auto",
          widget: "dxDropDownButton",
          options: {
            icon: "more",
            elementAttr: { class: "gc-dropdown-icon-button" },
            stylingMode: "text",
            showArrowIcon: false,
            disabled: this.gridToolbar.ellipsis.disabled == true ? true : false,
            items:
              this.gridToolbar.ellipsis && this.gridToolbar.ellipsis.menuItems
                ? this.gridToolbar.ellipsis.menuItems.map((el) => {
                    if (typeof el == "object")
                      return {
                        menuText: el.menuText,
                        visible: el.visible != undefined ? el.visible : true,
                        disabled:
                          el.disabled != undefined ? el.disabled : false,
                      };
                    else return { menuText: el };
                  })
                : [],
            keyExpr: "menuText",
            displayExpr: "menuText",
            dropDownOptions: { width: 150 },
            onItemClick: (e) => {
              if (this.gridToolbar.ellipsis.clickAction)
                this.gridToolbar.ellipsis.clickAction(e);
            },
            onButtonClick: (e) => {
              if (
                this.gridToolbar.ellipsis &&
                this.gridToolbar.ellipsis.onButtonClick
              )
                this.gridToolbar.ellipsis.onButtonClick(e);
            },
          },
        });
      }
    },
    onGroupExpand() {
      var dataGrid = this.$refs[this.gridRef].instance;
      if (this.groupExpand) {
        dataGrid.collapseAll(undefined);
      } else {
        dataGrid.expandAll(undefined);
      }

      setTimeout(() => {
        this.groupExpand = !this.groupExpand;
        dataGrid.repaint();
      }, 200);
    },
    detailsViewChanged(e) {
      this.$store.dispatch("dataContext/setDataViewType", e.value);
    },
    parseColumn(x) {
      let columnResult = {
        caption: x.gridLabel
          ? x.gridLabel
          : x.label instanceof Function
          ? x.label()
          : x.label,

        dataField: x.gridDataField ? x.gridDataField : x.dataField,
        minWidth: x.minWidth ? x.minWidth : x.width ? x.width : 200,
        visible: x.visible,
        cellTemplate: x.cellTemplate,
        cellTemplateRecord: x.cellTemplateRecord,
        exportFields: x.exportFields,
        allowGrouping: x.allowGrouping,
        sortOrder: x.sortOrder,
        sortIndex: x.sortIndex,
        calculateSortValue: x.calculateSortValue,
        allowEditing: x.allowEditing == undefined ? false : x.allowEditing,
        allowHiding: x.allowHiding,
        allowSearch: x.allowSearch == false ? x.allowSearch : true,
        showInColumnChooser:
          x.showInColumnChooser == false ? x.showInColumnChooser : true,
        headerCellTemplate: x.headerCellTemplate,
        allowSorting: x.allowSorting,
        defaultValue: x.defaultValue,
        makeReadOnly: x.makeReadOnly,
        makeDisabled: x.makeDisabled,
        valueChangeCallBack: x.valueChangeCallBack,
        showEditorAlways: x.showEditorAlways,
        hyperlink: x.hyperlink,
        gridUrlDataField: x.gridUrlDataField,
        gridUrlConditions: x.gridUrlConditions,
        cssClass: x.cssClass ? x.cssClass : undefined,
        globalField: x.dataField,
        screenField: x.fieldName,
        customTemplate: x.customTemplate,
        displayValue: x.displayValue,
        alignment: x.alignment != undefined ? x.alignment : undefined,
        editCellTemplate: x.editCellTemplate ? x.editCellTemplate : undefined,
        groupCellTemplate: x.groupCellTemplate
          ? x.groupCellTemplate
          : undefined,
        customCellDataField: x.customCellDisplayField
          ? x.customCellDisplayField
          : undefined,
        dataType: x.type == "String" ? "string" : undefined,
        filterDataField: x.filterDataField,
        format: x.format,
        hyperLinkDataField: x.hyperLinkDataField,
        minmax: x.minmax,
        calculateCellValue: x.calculateCellValue
          ? x.calculateCellValue
          : undefined,
        customFilter: x.customFilter ? x.customFilter : undefined,
        editorOptions: x.editorOptions,
        allowUpdate: x.allowUpdate,
        activeHyperLink: x.activeHyperLink ? x.activeHyperLink : undefined,
        customHyperLink: x.customHyperLink ? x.customHyperLink : undefined,
        dataPath: x.dataPath,

        makeAcceptCustomValue: x.makeAcceptCustomValue
          ? x.makeAcceptCustomValue
          : undefined,
        onCustomItemCreating: x.onCustomItemCreating
          ? x.onCustomItemCreating
          : undefined,
        filterDefaultValue: x.filterDefaultValue,
        onKeyDown: x.onKeyDown ? x.onKeyDown : undefined,
        lookup: x.lookup ? x.lookup : undefined,
        validationRules: x.validationRules ? x.validationRules : undefined,
        calculateGroupCellDisplayValue: x.calculateGroupCellDisplayValue
          ? x.calculateGroupCellDisplayValue
          : undefined,
        rowColorNegative:
          x.rowColorNegative != undefined ? x.rowColorNegative : false,
        customClass: x.customClass ? x.customClass : undefined,
        hyperLinkCallBack: x.hyperLinkCallBack,
        customizeText: x.customizeText,
        encodeHtml: x.encodeHtml,
        customBackGroundColor: x.customBackGroundColor,
      };

      if (x.visibleIndex) {
        columnResult.visibleIndex = x.visibleIndex;
      }

      if (x.columns) {
        columnResult.columns = x.columns
          .map((c) => {
            let globalField = getGlobalField(c.screenField);

            return { ...globalField, ...c }; // merge global field and the column definition
          })
          .filter((x) => x.dataField != null) // TODO: correct this condition to accommodate all valid columns
          .map((x) => {
            let column = this.parseColumn(x);
            return column;
          });
      }

      if (x.fixed) {
        columnResult.fixed = x.fixed;
        columnResult.fixedPosition = x.fixedPosition;
        columnResult.allowReordering = false;
      }
      if (x.ApplicationFeatureCode)
        columnResult.ApplicationFeatureCode = x.ApplicationFeatureCode;
      if (x.reportDataField) columnResult.reportDataField = x.reportDataField;

      if (x.groupIndex != undefined) {
        columnResult.groupIndex = x.groupIndex;
      }

      if (x.type === "Date") {
        columnResult.dataType = "date";
        columnResult.format = "dd MMM yyyy";
        columnResult.minWidth = 100;
        columnResult.width = 100;
        if (x.width) columnResult.width = x.width;
        if (x.minWidth) columnResult.minWidth = x.minWidth;
        if (x.editable != undefined) columnResult.editable = x.editable;
      }

      if (x.type === "DateTime") {
        columnResult.dataType = "datetime";
        columnResult.format = x.format || "dd MMM yyyy H:mm aa";
        columnResult.width = 250;
        columnResult.minWidth = 250;
        if (x.editable != undefined) columnResult.editable = x.editable;
      }

      if (x.type === "Time") {
        columnResult.dataType = "datetime";
        columnResult.format = "H:mm aa";
        columnResult.width = 150;
        columnResult.minWidth = 150;
        if (x.editable != undefined) columnResult.editable = x.editable;
        if (x.displayFormat) columnResult.format = x.displayFormat;
      }

      if (x.type === "Integer") {
        columnResult.alignment = x.alignment || "left";
        if (x.width && x.width > 0) {
          columnResult.width = x.width; // GCS-ChipWidth
          columnResult.minWidth = x.width;
        }
      }

      if (
        columnResult.cellTemplate === "Status" ||
        columnResult.cellTemplate === "ActiveStatus"
      ) {
        columnResult.width = 100; // GCS-ChipWidth
        columnResult.minWidth = 100;
        columnResult.allowEditing = false;
        columnResult.allowFiltering = true;

        columnResult.fixed = x.fixed != undefined ? x.fixed : true; // GCS-ChipFixedRight //HACK: Tablet scrolling doesnt worked on fixed columns
        columnResult.fixedPosition = "right"; // GCS-ChipFixedRight
        columnResult.alignment = "left"; // GCS-ChipAlignment
        columnResult.allowReordering = false;
        columnResult.showInColumnChooser = false;
      }

      if (x.type === "Decimal") {
        columnResult.caption = columnResult.caption.replace(
          "(Base Currency)",
          `(${getDefaultUserSettings().CurrencyCode})`,
        );
        columnResult.format = getDecimalFormat(x.format).ReadOnlyFormat;
        columnResult.alignment = "right";
        if (x.width && x.width > 0) {
          columnResult.width = x.width; // GCS-ChipWidth
          columnResult.minWidth = x.width;
        } else {
          columnResult.width = getDecimalFormat(x.format).Width;
          columnResult.minWidth = getDecimalFormat(x.format).Width;
        }

        if (x.cellTemplate != false) columnResult.cellTemplate = "Decimal";

        columnResult.caption = columnResult.caption.replace(
          "(Customer Currency)",
          `(${
            getDefaultCustomerSettings().CustomerCurrency
              ? getDefaultCustomerSettings().CustomerCurrency
              : ""
          })`,
        );
      }
      if (x.type === "EditableDecimal") {
        if (columnResult.caption) {
          columnResult.caption = columnResult.caption.replace(
            "(Base Currency)",
            `(${getDefaultUserSettings().CurrencyCode})`,
          );
          columnResult.caption = columnResult.caption.replace(
            "(Customer Currency)",
            `(${
              getDefaultCustomerSettings().CustomerCurrency
                ? getDefaultCustomerSettings().CustomerCurrency
                : ""
            })`,
          );
        }

        if (x.format) {
          columnResult.format = getDecimalFormat(x.format).EditFormat;
          columnResult.width = getDecimalFormat(x.format).Width;
        }
        columnResult.alignment = "right";
        columnResult.editCellTemplate = "EditableDecimal";
      }

      if (x.type == "DefaultDecimal") {
        columnResult.caption = columnResult.caption.replace(
          "(Base Currency)",
          `(${getDefaultUserSettings().CurrencyCode})`,
        );

        if (x.allowEditing) {
          columnResult.editorOptions.format = getDecimalFormat(
            x.format,
          ).EditFormat;
          // columnResult.editorOptions.onFocusIn = (e) => {
          //   e.event.target.select();
          // };
          columnResult.editorOptions.step = 0;
        } else {
          columnResult.format = getDecimalFormat(x.format).EditFormat;
        }
        columnResult.alignment = "right";
        columnResult.width = getDecimalFormat(x.format).Width;
        columnResult.cssClass = "edit-cell-numberbox-field";
        columnResult.dataType = "number";
      }

      if (x.type == "GridRecordEllipsisMenu") {
        columnResult.minWidth = 75;
        columnResult.width = 75;
        columnResult.fixed = x.fixed;
        columnResult.fixedPosition = x.fixedPosition;
        columnResult.ellipsisMenu = x.ellipsisMenu;
      }

      if (x.cellTemplateRecord)
        if (x.cellTemplateRecord.image) {
          columnResult.minWidth = 250;
          columnResult.alignment = "left";
          if (this.id == "grid-report-grid")
            columnResult.cellTemplateRecord.image = undefined;
        }

      if (x.type == "radio") {
        columnResult.minWidth = 75;
        columnResult.width = 75;
      }

      if (x.type == "Checkbox") {
        columnResult.width = x.width ? x.width : undefined;
        columnResult.minWidth = x.width ? x.width : columnResult.minWidth;
      }

      if (x.hyperlink && x.cellTemplate != "Record") {
        columnResult.cellTemplate = "Hyperlink";
      }

      if (
        x.cellTemplate == "SelectField" ||
        x.editCellTemplate == "SelectField"
      ) {
        columnResult.editorData = [
          {
            dataSourceConfig: x.dataSourceConfig,
            editorTemplate: x.editorTemplate,
            valueExpr: x.valueExpr,
            displayExpr: x.displayExpr,
            dataField: x.dataField,
            formLocation: "data-grid",
            readOnly: x.readOnly,
            fieldTemplate: x.fieldTemplate ? x.fieldTemplate : undefined,
            dropDownOptions: x.dropDownOptions ? x.dropDownOptions : undefined,
            editorOptions: x.editorOptions ? x.editorOptions : undefined,
            validationRules: x.validationRules,
            searchExpr: x.searchExpr,
            makeAcceptCustomValue: x.makeAcceptCustomValue,
            onCustomItemCreating: x.onCustomItemCreating,
          },
        ];
      }

      if (x.type == "RecordButton") {
        columnResult.width = 50;
        columnResult.minWidth = 50;
        columnResult.fixed = x.fixed;
        columnResult.fixedPosition = x.fixedPosition;
        if (x.ellipsisMenu) columnResult.ellipsisMenu = x.ellipsisMenu;
        if (x.menuItems) columnResult.menuItems = x.menuItems;
        if (x.PrintPreview) columnResult.PrintPreview = x.PrintPreview;
        if (x.BackgroundPrint) columnResult.BackgroundPrint = x.BackgroundPrint;
        if (x.BackgroundEmail) columnResult.BackgroundEmail = x.BackgroundEmail;
        if (x.ReferenceNoField)
          columnResult.ReferenceNoField = x.ReferenceNoField;
        if (x.ReferenceNoFields)
          columnResult.ReferenceNoFields = x.ReferenceNoFields;
        if (x.DeleteOptions) columnResult.DeleteOptions = x.DeleteOptions;
      }

      if (x.width) columnResult.width = x.width;
      if (x.minWidth) columnResult.minWidth = x.minWidth;

      if (x.customTemplate) columnResult.cellTemplate = "Custom";
      if (
        x.allowHiding == false &&
        x.forceWidth != true &&
        (x.fixedPosition != "right") & (x.type != "Checkbox")
      )
        columnResult.width = undefined;

      // columnResult.cellTemplate = undefined;
      if (
        columnResult.width &&
        this.baseView.mode != "create" &&
        this.baseView.mode != "edit"
      )
        columnResult.renderAsync = true;

      if (x.dataType) {
        columnResult.dataType = x.dataType;
      }

      columnResult.name = columnResult.caption;
      if (x.name) columnResult.name = x.name;

      // console.log("ZZZZ ", columnResult);

      if (
        columnResult.dataField == "ActionDelete" ||
        columnResult.dataField == "ActionAddNew" ||
        columnResult.dataField == "ActionCopy"
      ) {
        columnResult.allowFiltering = false;
        columnResult.allowSearch = false;
        columnResult.allowSorting = false;
        columnResult.allowHiding = false;
        columnResult.allowGrouping = false;
        columnResult.allowUpdate = false;
      }

      // console.log(">>>> ", columnResult);

      if (
        this.id == "transaction-list-grid" ||
        this.id == "grid-report-grid" ||
        this.id == "split-view-grid"
      ) {
        if (
          columnResult.cellTemplate &&
          columnResult.cellTemplate == "Record"
        ) {
          columnResult.cellTemplate = "GcRecordCell";
        }
      }

      if (
        columnResult.screenField == "GridRecordEmail" ||
        columnResult.screenField == "GridRecordPDFView" ||
        columnResult.screenField == "GridRecordPrint" ||
        columnResult.screenField == "GridRecordEllipsisMenu"
      ) {
        columnResult.minWidth = 30;
        columnResult.width = 30;
        columnResult.cssClass = "padding-0";

        if (x.dropDownOptions) columnResult.dropDownOptions = x.dropDownOptions;
      }

      if (x.maxWidth > 0) {
        columnResult.width = x.maxWidth;
        columnResult.minWidth = x.maxWidth;
      }

      if (x.editorType) {
        columnResult.editorType = x.editorType;
        if (x.setCellValue) columnResult.setCellValue = x.setCellValue;
      }

      if (x.lookup) {
        if (x.setCellValue) columnResult.setCellValue = x.setCellValue;
      }

      if (x.type == "buttons") {
        columnResult.type = x.type;
        if (x.buttons) columnResult.buttons = x.buttons;
      }

      if (this.id == "grid-report-grid") {
        columnResult.groupCellTemplate = "group-cell-template";
      }

      return columnResult;
    },
    appendHiddenColumns(columns) {
      let hiddenColumns = [];
      columns.forEach((col) => {
        if (col.exportFields && col.exportFields.length > 0) {
          col.exportFields.forEach((f) => {
            hiddenColumns.push({
              caption: f.label instanceof Function ? f.label() : f.label,
              type: col.type,
              dataField: f.dataField,
              width: f.width ? f.width : 200,
              visible: false,
              showInColumnChooser:
                col.showInColumnChooser == false
                  ? col.showInColumnChooser
                  : f.showInColumnChooser == false
                  ? false
                  : true,
              allowSearch:
                col.allowSearch == false
                  ? col.allowSearch
                  : f.allowSearch == false
                  ? false
                  : true,
              name: f.label,
              alignment: f.alignment ? f.alignment : undefined,
            });
          });
        }
      });

      columns.push(...hiddenColumns);

      return columns;
    },
    onGridToExcelExporting(e, fileName, originalColumn) {
      let visibleColumns = e.component.getVisibleColumns();
      exportGrid(e, fileName, originalColumn, {
        validationSummary: this.validationSummary.bind(this),
        persistenceKey: this.persistenceKey,
        storageGetter: CommonStorage.getItems.bind(CommonStorage),
        finalFilterValues: this.finalFilterValues,
        companyName: this.companyName,
        visibleColumns: [...visibleColumns],
      });
    },
    getGridDefaultOptions(key, defaultValue) {
      if (this.gridOptions && this.gridOptions.options) {
        if (this.gridOptions.options[key] != undefined)
          return this.gridOptions.options[key];
        else return defaultValue;
      } else return defaultValue;
    },
    configureDefaultGridOptions() {
      let grid = this.$refs[this.gridRef].instance;
      grid.option({
        // Here go the DataGrid options
        filterSyncEnabled: true,
        pager: {
          showPageSizeSelector: true,
          showInfo: true,
          visible: this.paging,
          allowedPageSizes:
            this.gridOptions &&
            this.gridOptions.options &&
            this.gridOptions.options.allowedPageSizes
              ? this.gridOptions.options.allowedPageSizes
              : "auto",
        },
        // paging: {
        // enabled: false,
        // pageSize:
        //   this.gridOptions &&
        //   this.gridOptions.options &&
        //   this.gridOptions.options.pageSize
        //     ? this.gridOptions.options.pageSize
        //     : 100,
        // },
        filterRow: { visible: false },

        elementAttr: { class: "dx-card wide-card" },
        columnMinWidth: 50,
        allowColumnReordering: true,
        showBorders: false,
        showColumnLines: this.getGridDefaultOptions("showColumnLines", false),
        focusedRowEnabled: this.getGridDefaultOptions(
          "focusedRowEnabled",
          false,
        ),
        columnAutoWidth: true,
        columnHidingEnabled: false,
        selection: {
          deferred:
            this.gridOptions &&
            this.gridOptions.options &&
            this.gridOptions.options.deferred != undefined
              ? this.gridOptions.options.deferred
              : false,
          mode:
            this.gridOptions &&
            this.gridOptions.options &&
            this.gridOptions.options.selectionMode != undefined
              ? this.gridOptions.options.selectionMode
              : "single",
          showCheckBoxesMode: "always",
          selectAllMode: "allPages",
          allowSelectAll:
            this.gridOptions &&
            this.gridOptions.options &&
            this.gridOptions.options.allowSelectAll != undefined
              ? this.gridOptions.options.allowSelectAll
              : true,
        },
        hoverStateEnabled: true,
        columnFixingEnabled: true,
        wordWrapEnabled:
          this.gridOptions &&
          this.gridOptions.options &&
          this.gridOptions.options.wordWrapEnabled != undefined
            ? this.gridOptions.options.wordWrapEnabled
            : true,
        twoWayBindingEnabled: true,
        searchPanel: {
          visible: true,
          highlightCaseSensitive: true,
          highlightSearchText: false,
        },
        columnChooser: {
          enabled: true,
          allowSearch: true,
          mode: "select",
          height: "100%",
          width: 300,
        },
        noDataText: "",
        repaintChangesOnly:
          this.gridOptions &&
          this.gridOptions.options &&
          this.gridOptions.options.repaintChangesOnly != undefined
            ? this.gridOptions.options.repaintChangesOnly
            : false,
      });
    },
    addGridNoResultsOLD(e) {
      if (!e) return;
      // setTimeout(() => {
      this.dataGridForNoData = { ...e };
      let masterDetails = e.element.querySelector(".dx-master-detail-row");
      let noData = e.element.querySelector(
        ".dx-datagrid-nodata:not(.dx-hidden)",
      );
      if (
        noData &&
        masterDetails == null &&
        noData.innerHTML.indexOf("content-block home-content") == -1
      ) {
        noData.innerHTML = `<div class="content-block home-content" ref="home-content">
        <img class="no-data" width="270" />
        <div class="details-div">
        <span class='oops'>Uh-osdsdsh!</span>
          <p class="p-details">
          We are struggling to find what you are looking for. Try altering your
          search criteria.
        </p>
        </div>
      </div>`;
      }

      // // eslint-disable-next-line no-console
      // console.log(noData, "XXXX");
      // if (noData && masterDetails == null) {

      // }

      this.$store.dispatch("ui/checkGridNoData", false);
      // }, 200);

      setTimeout(() => {
        this.reSizeGrid();
      }, 50);
    },
    addGridNoResults(e) {
      if (this.gridOptions && this.gridOptions.hideNoDataImage) {
        return true;
      }
      setTimeout(() => {
        // this.reSizeGrid();
        var data = undefined;

        if (
          this.gridOptions &&
          this.gridOptions.noDataMessage &&
          !e.component.state().searchText &&
          !this.isAdvanceFilterApplied
        ) {
          if (
            this.gridOptions.noDataMessage[this.dataGridView] &&
            this.gridOptions.noDataMessage[this.dataGridView].addNew
          ) {
            data = this.gridOptions.noDataMessage[this.dataGridView].addNew;
          } else data = this.gridOptions.noDataMessage.addNew;
        } else if (
          this.gridOptions &&
          this.gridOptions.noDataMessage &&
          e.component.state().searchText &&
          !this.isAdvanceFilterApplied
        ) {
          if (
            this.gridOptions.noDataMessage[this.dataGridView] &&
            this.gridOptions.noDataMessage[this.dataGridView].addNew
          ) {
            data = this.gridOptions.noDataMessage[this.dataGridView].addNew;
            data.title = "Uh-oh!";
            data.message =
              "We are struggling to find what you are looking for. Try altering your search criteria";
          } else if (this.gridOptions.noDataMessage.addNew) {
            data = this.gridOptions.noDataMessage.addNew;
            data.title = "Uh-oh!";
            data.message =
              "We are struggling to find what you are looking for. Try altering your search criteria";
          }
        }

        if (!data)
          data = {
            class: "no-data",
            title: "Uh-oh!",
            message:
              "We are struggling to find what you are looking for. Try altering your search criteria",
          };

        let masterDetails = e.element.querySelector(".dx-master-detail-row");
        let noData = e.element.querySelector(
          ".dx-datagrid-nodata:not(.dx-hidden)",
        );

        let gridContentArea = e.element.querySelector(".dx-datagrid-rowsview");

        if (noData && gridContentArea && gridContentArea.clientHeight < 200) {
          data.class = data.class + " hide";
        }

        this.formsConfig.dataGridForNoData = this.dataGridForNoData = e;
        if (noData && masterDetails == null && !data.small) {
          noData.innerHTML = `<div class="content-block home-content" ref="home-content">
                                <img class="${data.class}" width="300" />
                                <div class="details-div">
                                  <span class='oops'>${data.title}</span>
                                  <p class="p-details"> ${data.message}</p>
                                </div>
                              </div>`;
        } else if (noData && masterDetails == null && data.small) {
          let img = `<img class="${data.class}" width="140" height="140" />`;
          if (data.noImage) img = "";
          noData.innerHTML = `<div class="content-block home-content" ref="home-content">
                                ${img}
                                <div>
                                  <span class='sm-oops'>${data.title}</span><br>
                                  <span> ${data.message}</span>
                                </div>
                              </div>`;
        }
        this.$store.dispatch("ui/checkGridNoData", false);

        setTimeout(() => {
          // e.component.beginUpdate();
          // e.component.updateDimensions();
          // e.component.endUpdate();
          // this.reSizeGrid();
        }, 200);
      }, 200);
    },

    reSizeGrid() {
      if (!this.dataGridForNoData) return;
      var e = this.dataGridForNoData;

      e.component.beginUpdate();
      e.component.updateDimensions();
      e.component.endUpdate();

      setTimeout(() => {
        this.$store.dispatch("ui/checkGridNoData", true);
      }, 50);
    },
    selectRowsByIndexes(indexes) {
      let grid = this.$refs[this.gridRef].instance;
      grid.selectRowsByIndexes(indexes);
    },
    selectRows(keys) {
      let grid = this.$refs[this.gridRef].instance;
      grid.selectRows(keys, true);
    },
  },
  watch: {
    dataViewType(val) {
      this.dataGridView = val;
      if (dataGridViewsSelectBox) dataGridViewsSelectBox.option("value", val);
    },
    itemsMutationIndex: function () {
      if (this.showFooter)
        this.$store.dispatch("dataContext/setDataContext", {
          key: "gcDataGrid",
          value: this.gridDataSourceItems,
        });
    },
    viewRouted(val) {
      if (val) this.reSizeGrid();
      this.$store.dispatch("ui/setViewRouted", false);
    },
    checkGridNoData(val) {
      if (val && this.dataGridForNoData) {
        this.addGridNoResults(this.dataGridForNoData);
      }
    },
    gridExpand() {
      var grid = this.$refs[this.gridRef].instance;
      grid.refresh(true);
    },
    gridDataSourceItems: function (newVal) {
      if (this.showFooter)
        this.$store.dispatch("dataContext/setDataContext", {
          key: "gcDataGrid",
          value: newVal,
        });
    },
    updateGridOnDefault(val) {
      if (val) {
        let grid = this.$refs[this.gridRef].instance;
        // var items = grid.getDataSource().items();
        // if (items)
        //   items.forEach((element) => {
        //     if (element.Code == this.updateIsDefaultCode)
        //       element.IsDefault = "Y";
        //     // else element.IsDefault = "N";
        //   });

        grid.getDataSource().reload();

        this.$store.dispatch("ui/setUpdateGridOnDefault", false);
        this.$store.dispatch("ui/setUpdateIsDefault", {
          update: false,
          code: undefined,
        });
      }
    },
  },
  beforeCreate() {
    CommonStorage.clear("searchText");
  },
};
</script>

<style lang="scss">
.dx-toolbar
  .dx-item-content
  .dx-widget.dx-datagrid-export-button
  .dx-buttongroup.dx-widget
  .dx-buttongroup-wrapper
  .dx-item.dx-buttongroup-item {
  border-radius: unset;
}
.class-custom-btn {
  .dx-button .dx-icon {
    font-size: 16px;
    margin-right: 0px;
    padding: 0px;
  }

  .dx-button-has-icon .dx-button-content {
    padding: 0px;
    // padding-left: 3px !important;
  }

  .dx-button {
    height: 25px !important;
    min-width: 25px !important;
  }
}

.dx-datagrid-nodata {
  font-size: 15px;
  color: rgba(102, 102, 102, 0.87);
  .details-div {
    padding-bottom: 10px;
  }
}

.view-card {
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
    0 1px 2px rgba(0, 0, 0, 0.24);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  background-color: #fff;
  margin: 2px 0px 3px;
}

.dx-datagrid-header-panel {
  padding-left: 14px;
}

.dx-texteditor-input {
  color: black;
}

/**  datagrid styles */
.dx-row.dx-data-row.dx-row-lines .gc-editor-cell {
  position: relative;
}

.dx-row.dx-data-row.dx-row-lines .gc-editor-cell.dx-datagrid-invalid {
  position: unset;
}

.dx-row.dx-data-row.dx-row-lines .gc-editor-cell.dx-datagrid-invalid:before {
  content: none;
}

/**  master detail datagrid styles */
.master-detail-caption {
  padding: 0 0 5px 10px;
  font-size: 14px;
  font-weight: bold;
}

.dx-datagrid-revert-tooltip
  .dx-revert-button.dx-button-has-icon:not(.dx-button-has-text) {
  display: none;
}

.dx-datagrid-rowsview
  .dx-adaptive-detail-row.dx-selection:hover:not(.dx-edit-row)
  .dx-cell-modified,
.dx-datagrid-rowsview
  .dx-adaptive-detail-row.dx-selection:not(.dx-edit-row)
  .dx-cell-modified,
.dx-datagrid-rowsview
  .dx-adaptive-detail-row:not(.dx-edit-row)
  .dx-cell-modified,
.dx-datagrid-rowsview
  .dx-data-row.dx-selection:hover:not(.dx-edit-row)
  .dx-cell-modified,
.dx-datagrid-rowsview
  .dx-data-row.dx-selection:not(.dx-edit-row)
  .dx-cell-modified,
.dx-datagrid-rowsview .dx-data-row:not(.dx-edit-row) .dx-cell-modified {
  background-color: transparent !important;
}

.view-toolbar .dx-state-disabled .dx-widget,
.dx-toolbar .dx-state-disabled .dx-widget {
  opacity: 1;
}

/** dx data grid toolbar related */
.view-toolbar
  .dx-item-content
  .dx-widget
  .dx-buttongroup.dx-widget
  .dx-buttongroup-wrapper
  .dx-item.dx-buttongroup-item,
.dx-toolbar
  .dx-item-content
  .dx-widget
  .dx-buttongroup.dx-widget
  .dx-buttongroup-wrapper
  .dx-item.dx-buttongroup-item {
  border-radius: 50%;
}

.view-toolbar
  .dx-item-content
  .dx-widget
  .dx-buttongroup.dx-widget
  .dx-button-content,
.dx-toolbar
  .dx-item-content
  .dx-widget
  .dx-buttongroup.dx-widget
  .dx-button-content {
  padding-right: 6px;
  padding-left: 6px;
}

.view-toolbar
  .dx-item-content
  .dx-widget
  .dx-buttongroup.dx-widget
  .dx-button-content
  .dx-icon,
.dx-toolbar
  .dx-item-content
  .dx-widget
  .dx-buttongroup.dx-widget
  .dx-button-content
  .dx-icon {
  color: rgba(148, 148, 148, 0.87);
}

.view-toolbar .dx-item-content .dx-button .dx-button-content,
.dx-toolbar .dx-item-content .dx-button .dx-button-content {
  padding-right: 6px;
  padding-left: 6px;
}

.view-toolbar .dx-item-content .dx-button .dx-button-content .dx-icon,
.dx-toolbar .dx-item-content .dx-button .dx-button-content .dx-icon {
  color: rgba(148, 148, 148, 0.87);
}

.dx-datagrid-search-panel .dx-icon-search {
  display: none;
}

.dx-datagrid-search-panel input,
.dx-datagrid-search-panel .dx-placeholder:before {
  padding-left: 5px !important;
}

.dx-datagrid-rowsview {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}

.dx-datagrid-rowsview .more-menu {
  padding: 0 !important;
}

.dx-datagrid-rowsview .more-menu .dx-button-mode-text .dx-icon {
  color: rgba(148, 148, 148, 0.87);
}

.dx-datagrid-rowsview .more-menu .dx-button-content .dx-icon {
  color: rgba(148, 148, 148, 0.87);
}

.dx-datagrid .dx-datagrid-filter-row {
  background-color: #ffffff;
}

.dx-datagrid tbody .dx-row.dx-header-row {
  background-color: #bbbbbb29;
  .multi-header-title {
    text-align: center !important;
  }
}

.dx-datagrid
  tbody
  .dx-row.dx-datagrid-filter-row
  .dx-texteditor-input-container
  input {
  font-size: 12px;
  padding-left: 16px !important;
}

.dx-datagrid
  tbody
  .dx-row.dx-datagrid-filter-row
  .dx-menu
  .dx-menu-item
  .dx-menu-item-content {
  padding-left: 0;
  padding-right: 0;
}

.dx-datagrid
  tbody
  .dx-row.dx-datagrid-filter-row
  .dx-menu
  .dx-menu-item
  .dx-menu-item-content
  .dx-icon.dx-icon-filter-operation-default {
  font-size: 20px;
}

.details-view .dx-toolbar-before {
  padding-left: 30px;
}

.details-view
  .dx-datagrid-rowsview
  .dx-datagrid-content
  tbody
  .dx-row
  .dx-button.dx-state-disabled.dx-button-has-icon {
  opacity: 1;
  background: transparent;
}

.details-view .split-view-toolbar .dx-toolbar-before {
  padding: 0;
}

.dx-datagrid-header-panel .dx-datagrid-search-panel {
  width: 250px !important;
}

.view-toolbar .dx-toolbar-items-container .dx-toolbar-after .dx-form .dx-switch,
.split-view-toolbar.dx-toolbar .dx-toolbar-after .dx-form .dx-switch {
  margin-top: 4px;
  margin-bottom: 4px;
}

.view-toolbar
  .dx-toolbar-items-container
  .dx-toolbar-after
  .dx-form
  .dx-first-row.dx-field-item.dx-label-h-align,
.split-view-toolbar.dx-toolbar
  .dx-toolbar-after
  .dx-form
  .dx-first-row.dx-field-item.dx-label-h-align {
  padding-bottom: 0;
}

.view-toolbar .dx-form .dx-item-content .dx-item.dx-box-item {
  width: 380px;
}

.dx-state-disabled {
  pointer-events: auto;
}

.view-toolbar
  .dx-dropdownbutton
  .dx-buttongroup
  .dx-buttongroup-wrapper
  .dx-buttongroup-item
  .dx-button-content {
  padding-right: 6px;
}

.dx-datagrid .dx-row > td.gc-grid-qty-container {
  padding-top: 0px;
  padding-bottom: 0px;
  padding-right: 5px;
}

.dx-datagrid .dx-row > td {
  padding-right: 5px;
  font-size: 12px;
}

td[role="columnheader"] {
  vertical-align: text-top !important;
}

.dx-datagrid-content .gc-grid-number-box-editor .dx-texteditor-input {
  font-size: 14px;
}

.dx-datagrid-content
  .dx-datagrid-table
  .dx-row
  .dx-editor-cell
  .gc-grid-number-box-editor {
  position: relative;
}

.dx-datagrid-content
  .dx-datagrid-table
  .dx-row
  .dx-editor-cell
  .gc-grid-number-box-editor:after {
  content: "";
  position: absolute;
  bottom: 0;
  height: 0.09rem;
  background-color: rgba(0, 0, 0, 0.1);
  left: 0;
  right: 0;
}

.dx-datagrid-content
  .dx-datagrid-table
  .dx-row
  .dx-editor-cell
  .gc-grid-number-box-editor.dx-state-focused:after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  height: 2px;
  width: 100%;
  /* or 100px */
  background-color: #35baf6;
}

.dx-datagrid-content
  .dx-datagrid-table
  .dx-texteditor.dx-editor-underlined.dx-state-disabled:after {
  border-bottom-color: #000000 !important;
  opacity: 1 !important;
}

.dx-datagrid-content
  .dx-datagrid-table
  .key-pad-focused
  .dx-texteditor.dx-editor-underlined:after {
  border-bottom: none;
}

.dx-datagrid-content
  .dx-datagrid-table
  .gc-grid-number-box-editor.dx-state-disabled {
  opacity: 1 !important;
}

.dx-datagrid-content
  .dx-datagrid-table
  .dx-row
  .dx-editor-cell
  .gc-grid-number-box-editor.dx-state-disabled {
  box-sizing: border-box !important;
  opacity: 1 !important;
}

.dx-datagrid-content
  .dx-datagrid-table
  .dx-row
  .dx-editor-cell
  .gc-grid-number-box-editor.dx-state-disabled:after {
  content: "";
  height: 0;
}

.dx-datagrid-content .dx-datagrid-table .gc-auto-cmp {
  border-bottom-color: black;
  border-bottom-style: dotted;
  border-bottom-width: 1px;
}

.dx-datagrid-content
  .dx-datagrid-table
  .dx-row
  .gc-default-editor.dx-editor-cell
  .dx-texteditor-input {
  border-bottom-color: black;
  border-bottom-style: dotted;
  border-bottom-width: 1px;
}

.dx-datagrid-content
  .dx-datagrid-table
  .dx-row
  .gc-editor-cell-default-editor.dx-editor-cell
  .dx-texteditor-input {
  border-bottom: none;
}

.dx-datagrid-content
  .dx-datagrid-table
  .dx-row
  .gc-editor-cell-default-editor.dx-editor-cell
  .dx-texteditor-input-container:after {
  content: "";
  position: absolute;
  bottom: 0;
  height: 0.09rem;
  background-color: rgba(0, 0, 0, 0.42);
  left: 0;
  right: 0;
}

.dx-datagrid-content
  .dx-datagrid-table
  .dx-row
  .gc-editor-cell-default-editor.dx-editor-cell.dx-editor-cell.dx-focused
  .dx-texteditor-input-container:after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  height: 2px;
  width: 100%;
  /* or 100px */
  background-color: #35baf6;
}

.dx-datagrid-content .dx-datagrid-table .gc-editor-cell .gc-auto-cmp {
  border-bottom: none;
}

.dx-datagrid-content
  .dx-datagrid-table
  .dx-row
  .gc-border-bottom-dotted.dx-state-disabled {
  opacity: 1;
}

.dx-datagrid-content
  .dx-datagrid-table
  .dx-row
  .gc-border-bottom-dotted.dx-state-disabled::after {
  border-bottom-color: #000000 !important;
}

.dx-texteditor.dx-editor-underlined.dx-state-hover:after {
  border-bottom: 1px solid #35baf6;
}

.dx-datagrid-focus-overlay:after {
  background-color: transparent;
}

.dx-datagrid .avail-error {
  color: #ff0000 !important;
}

.dx-datagrid .avail-error .gc-available-label-qty input {
  color: #ff0000 !important;
}

.dx-datagrid .avail-no-error {
  background-color: transparent;
}

.dx-datagrid
  .dx-row.dx-data-row.dx-row-lines
  .gc-editor-cell
  .key-pad-focused
  .gc-grid-number-box-editor:after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  height: 2px;
  width: 100%;
  /* or 100px */
  background-color: #35baf6;
}

.dx-datagrid .dx-row.dx-data-row.dx-row-lines .gc-editor-cell .dx-lookup-field,
.dx-datagrid .dx-item-content.dx-list-item-content {
  font-size: 14px;
}

.dx-datagrid
  .dx-row.dx-data-row.dx-row-lines
  .gc-editor-cell.dx-focused
  .dx-dropdowneditor:after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  height: 2px;
  width: 100%;
  /* or 100px */
  background-color: #35baf6;
}

.dx-datagrid
  .dx-row.dx-data-row.dx-row-lines
  .gc-editor-cell
  .dx-dropdowneditor:after {
  content: " ";
  position: absolute;
  bottom: 0;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  left: 0;
  right: 0;
}

.dx-datagrid .dx-row .dx-widget input.dx-texteditor-input {
  height: 20px;
  min-height: 20px;
}

.dx-datagrid .dx-scrollable-scrollbar.dx-scrollbar-horizontal,
.dx-datagrid
  .dx-scrollable-scrollbar.dx-scrollbar-horizontal
  .dx-scrollable-scroll {
  height: 15px;
}

.dx-datagrid td {
  border-left-style: none !important;
  border-right-style: none !important;
  border-left-style: none !important;
  /*May need to comment this out when supporting keyboard navigation but it allows us to scroll a fixed column vertically*/
}

td .dx-datagrid-content-fixed .dx-datagrid-table-fixed .dx-data-row > td {
  pointer-events: none;
}

.dx-datagrid
  .dx-row.dx-datagrid-filter-row
  .dx-widget
  input.dx-texteditor-input {
  height: 48px !important;
}

/*Fix ipad showing sales order qty copped off at bottom*/
.dx-datagrid
  .dx-texteditor-container
  .dx-texteditor-input-container
  .dx-texteditor-input,
.gc-so-note-template,
.gc-auto-cmp,
.gc-auto-cmp-editor,
.dx-lookup-field {
  line-height: 30px !important;
  height: 30px !important;
}

.dx-toolbar .dx-item .dx-form .dx-widget.dx-state-disabled {
  opacity: 1;
}

.dx-button[aria-label="Add New"] {
  background-color: #03a9f4;
  color: #fff !important;

  span {
    padding-right: 5px;
  }

  .dx-button-content .dx-icon::before {
    color: #fff !important;
  }
}

.dx-button[aria-label="Add New"].dx-state-disabled {
  background-color: #03a9f4;
  color: #fff !important;

  .dx-button-text {
    color: #fff !important;
  }
}

.dx-button[aria-label="Add Item"],
.dx-button.dx-button-has-text[aria-label="Collapse"],
.dx-button.dx-button-has-text[aria-label="Expand"] {
  background-color: #03a9f4;
  color: #fff !important;

  span {
    padding-right: 5px;
  }

  .dx-button-content .dx-icon::before {
    color: #fff !important;
  }
}

.dx-button[aria-label="Add Item"].dx-state-hover,
.dx-button.dx-button-has-text[aria-label="Collapse"].dx-state-hover,
.dx-button.dx-button-has-text[aria-label="Expand"].dx-state-hover {
  background-color: #0075a9;
}
.dx-button[aria-label="Add Item"].dx-state-focused,
.dx-button.dx-button-has-text[aria-label="Collapse"].dx-state-focused,
.dx-button.dx-button-has-text[aria-label="Expand"].dx-state-focused {
  background-color: #0075a9;
}

.dx-button[aria-label="Link an Item"] {
  background-color: #03a9f4;
  color: #fff !important;

  span {
    padding-right: 5px;
  }

  .dx-button-content .dx-icon::before {
    color: #fff !important;
  }
}

.dx-button[aria-label="Add Invoice"] {
  background-color: #03a9f4;
  color: #fff !important;

  span {
    padding-right: 5px;
  }

  .dx-button-content .dx-icon::before {
    color: #fff !important;
  }
}

.dx-button[aria-label="New Batch Payment"] {
  background-color: #03a9f4;
  color: #fff !important;

  span {
    padding-right: 5px;
  }

  .dx-button-content .dx-icon::before {
    color: #fff !important;
  }
}

.dx-datagrid-content .gc-grid-number-box-editor .dx-texteditor-input {
  font-size: 14px;
}

.dx-datagrid-content
  .dx-datagrid-table
  .dx-row
  .dx-editor-cell
  .gc-grid-number-box-editor {
  position: relative;
}

.dx-datagrid-content
  .dx-datagrid-table
  .dx-row
  .dx-editor-cell
  .gc-grid-number-box-editor:after {
  content: "";
  position: absolute;
  bottom: 0;
  height: 0.09rem;
  background-color: rgba(0, 0, 0, 0.1);
  left: 0;
  right: 0;
}

.dx-datagrid-content
  .dx-datagrid-table
  .dx-row
  .dx-editor-cell
  .gc-grid-number-box-editor.dx-state-focused:after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  height: 2px;
  width: 100%;
  /* or 100px */
  background-color: #35baf6;
}

.dx-datagrid-content
  .dx-datagrid-table
  .dx-row
  .dx-editor-cell.edit-cell-textbox-field
  .dx-selectbox.dx-state-focused:not(.dx-tagbox) {
  border-bottom: unset !important;
  :after {
    content: "";
    position: absolute;
    right: 0;
    bottom: 0;
    height: 2px;
    width: 100%;
    /* or 100px */
    background-color: #35baf6;
    // border-bottom: unset !important;
  }
}

.dx-datagrid-content
  .dx-datagrid-table
  .gc-grid-number-box-editor.dx-state-disabled {
  opacity: 1 !important;
}

.dx-datagrid-content
  .dx-datagrid-table
  .dx-row
  .dx-editor-cell
  .gc-grid-number-box-editor.dx-state-disabled {
  box-sizing: border-box !important;
  opacity: 1 !important;
}

.dx-datagrid-content
  .dx-datagrid-table
  .dx-row
  .dx-editor-cell
  .gc-grid-number-box-editor.dx-state-disabled:after {
  content: "";
  height: 0;
}
.dx-datagrid
  .dx-row.dx-data-row.dx-row-lines
  .gc-editor-cell
  .key-pad-focused
  .gc-grid-number-box-editor:after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  height: 2px;
  width: 100%;
  /* or 100px */
  background-color: #35baf6;
}

.dx-datagrid .avail-error .dx-texteditor-input {
  color: #ff0000;
}

a:hover {
  cursor: pointer;
}

.column-checkBox {
  text-align: center !important;
}

.grid-text-scroll {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  vertical-align: middle !important;
}

.dx-command-expand.dx-datagrid-expand {
  vertical-align: middle !important;
}

.check-include {
  vertical-align: middle !important;
}

.radio-btn-x {
  vertical-align: middle !important;
}

.dx-datagrid-rowsview {
  .dx-row > td {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
    // font-size: 12px !important;
    // line-height: 20px;
  }
}

.dx-datagrid-pager.dx-pager {
  padding: 10px 11px 10px 20px;
}

.dx-datagrid-header-panel {
  padding: 0 10px 0 12px;
}

.rowColorNegative {
  background-color: #f0b3b3 !important;
}

.download-cell-template::before {
  font-size: 22px;
}

.gc-require-validation::after,
.gc-require-validation .dx-texteditor::after {
  border-bottom: 2px solid rgb(255 0 0) !important;
}
</style>
